import { useEffect, useState, useRef, useContext } from "react";
import { DataTable, DataTableExpandedRows } from "primereact/datatable";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import {
  locale,
  addLocale,
  FilterMatchMode,
  FilterService,
} from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import PdfCreator from "../../../components/generate-pdf-from-data/generatePdfFromDataOrdenes";
import "./index.css";
import "../shared/estadoDialog.css";
import Avatar from "/src/assets/images/male-avatar.png";
import * as api from "../../../utils/Api.ts";
import UploadFile from "../../widgets/UploadFile.tsx";
import DownloadFiles from "../../widgets/DownloadFiles.tsx";
import {
  AUX_TIPO_DOCUMENTO_INET_CONVERT,
  CENTRO_COSTO_ALIMENTOS_ADQUISICION,
  CONVERT_DATE_TO_INET_FORMAT,
  FILTER_ITEMS_BY_DOC_TYPE,
  getUserIp,
  parseNumberCommaFormatForOperations,
  showMsg,
  VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT,
  VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE,
  appEnv,
  AUX_CONDICION_PAGO_INET_CONVERT,
  FORMAT_TEXT_FOR_INET,
  USUARIOS_CONFIRMACION_ORDENES,
  USUARIO_CONFIRMA_GTE_GENERAL,
  USUARIO_TI,
  SHOW_MSG_ACTION,
  CENTRO_COSTO_ADQUISICION,
  IS_MOBILE,
  EMAIL_ADQUISICIONES,
  AUX_VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE,
  USUARIOS_ADQUISICIONES,
  USUARIO_JEFE_ABASTECIMIENTO,
  FORMAT_DATETIME_DDMMYYYY,
  FORMAT_DATETIME_DDMMYYYY_GUION,
} from "../../../utils/Constants.tsx";
import { InitDataContext } from "../../../context/InitDataContext.tsx";
import { InitDataForTablesContext } from "../../../context/InitDataForTables.tsx";
import { InitDataNewOrderContext } from "../../../context/InitDataNewOrder.tsx";
import { InputNumber } from "primereact/inputnumber";
import DropdownFilter from "../../dropdown/DropdownFilter.tsx";
import ModalConfirm from "../../ui/modal/ModalConfirm.tsx";
import ModalSignature from "../../ui/modal/ModalSignature";
import ModalLoadSpinner from "../../ui/modal/ModalLoadSpinner.tsx";
import EstadosOrdenLeyenda from "./EstadosOrdenLeyenda.tsx";
import CargandoDatos from "../shared/CargandoDatos.tsx";
import { useScrollbarGutter } from "../../reportes/reportesUtils.ts";
import { Toast } from "primereact/toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import DOMPurify from "dompurify";
import CreatePdfTableOrdenesBlob from "../../../components/generate-pdf-from-data/generatePdfAsAttachment.tsx";
import "../../../utils/main.css";
import ShowFilesRepo from "../../widgets/ShowFilesRepo.tsx";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

type Detalle = {
  cantidad: any;
  item: any;
  centrocosto: any;
  proveedor: any;
  preciorefunitario: any;
  preciorefunitariototal: any;
  detalles: string;
};

type Solicitud = {
  tiposolicitud: number;
  mesgasto: number;
  estadooperacional: number;
  tipomoneda: number;
  detalles: Detalle[];
};

function TableDataOrderMaintenance({ contextmenu }: { contextmenu: string }) {
  const ordenesCompra = useRef();
  const ordenesCompraDetalles = useRef();
  const { initData, parametros } = useContext(InitDataContext);
  const navigate = useNavigate();
  const {
    itemsAdquisicionFull,
    itemsAdquisicion,
    centrosCosto,
    centrosCostoFull,
    proveedores,
    tipoSolicitudes,
    meses,
    estadosOperacionales,
    tiposMoneda,
    tiposItemsAdquisicion,
    estadosOrdenes,
  } = useContext(InitDataForTablesContext);

  const itemsFiltered = useRef(itemsAdquisicion);
  useEffect(() => {
    if (itemsFiltered.current.length == 0) {
      itemsFiltered.current = FILTER_ITEMS_BY_DOC_TYPE(
        itemsAdquisicion,
        0,
        tiposItemsAdquisicion,
      );
    }
  }, [itemsAdquisicion]);

  const [goHome, setGoHome] = useState(false);
  useEffect(() => {
    if (goHome) {
      //navigate("/ordenes-compra/mantenciones", { replace: true });
      window.location.reload();
    }
  }, [goHome]);

  const { tiposDocumentosTributarios, condicionesPago } = useContext(
    InitDataNewOrderContext,
  );
  /*****************************************/
  const [selectedCantidad, setSelectedCantidad] = useState<number>(0);
  const [selectedItemId, setSelectedItemId] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState<string>("Seleccione...");
  const [selectedProveedorId, setSelectedProveedorId] = useState<number>(0);
  const [selectedProveedor, setSelectedProveedor] =
    useState<string>("Seleccione...");
  const [selectedPrecioUnitarioRef, setselectedPrecioUnitarioRef] =
    useState<number>(0);
  const [selectedPrecioTotalRef, setSelectedPrecioTotalRef] =
    useState<number>(0);
  const selectedDetalles = useRef<string>();
  const [selectedEstado, setSelectedEstado] = useState<string>("");
  const [selectedEstadoId, setSelectedEstadoId] = useState<number>(0);
  const [selectedMesGastoId, setSelectedMesGastoId] = useState<number>(0);
  const [selectedMesGasto, setSelectedMesGasto] = useState<string>("");
  const [selectedTipoOrdenId, setSelectedTipoOrdenId] = useState<number>(0);
  const [selectedTipoOrden, setSelectedTipoOrden] =
    useState<string>("Seleccione...");
  const [selectedEstadoOpId, setSelectedEstadoOpId] = useState<number>(0);
  const [selectedEstadoOp, setSelectedEStadoOp] =
    useState<string>("Seleccione...");
  const [selectedTipoMonedaId, setSelectedTipoMonedaId] = useState<number>(0);
  const [selectedTipoMoneda, setSelectedTipoMoneda] =
    useState<string>("Seleccione...");
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [jsonDataOrdenCompra, setJsonDataOrdenCompra] = useState<Solicitud>();
  const [selectedNumeroOrdenCompra, setSelectedNumeroOrdenCompra] =
    useState<number>(0);
  const [selectedDetailRowId, setSelectedDetailRowId] = useState<number>(0);
  const selectedJustificacion = useRef();
  const ordenesCompraApprovalStates = useRef<any[]>([]);
  const [showModalLoadSpinner, setShowModalLoadSpinner] = useState(false);
  const ordenesSignApprovalHistory = useRef<any[]>([]);
  const dataProveedor = useRef<any>({});
  const [selectedTipoDocTributarioId, setSelectedTipoDocTributarioId] =
    useState<number>(0);
  const [selectedTipoDocTributario, setSelectedTipoDocTributario] =
    useState<string>("Seleccione...");
  const [selectedCondicionPagoId, setSelectedCondicionPagoId] =
    useState<number>(0);
  const [selectedCondicionPago, setSelectedCondicionPago] =
    useState<string>("Seleccione...");
  const [needFetchingDoc, setNeedFetchingDoc] = useState(false);
  const ordenConfirmedForInet = useRef<any>({});
  const [searchParams, setSearchParams] = useSearchParams();
  const [loadingMessage, setLoadingMessage] = useState("Procesando...");
  const [msgAfterApproval, setMsgAfterApproval] = useState<string>(
    "Estado registrado exitosamente",
  );

  let emptyNewDetaille = {
    cantidad: 0,
    id_item: 0,
    id_centro_costo_asociado: 0,
    id_proveedor: 0,
    observaciones: "",
    precio_unitario_ref: 0,
    precio_total_ref: 0,
    id_estado_solicitud: 1,
    dt_cre: new Date(),
    dt_mod: new Date(),
  };

  const rolesDeconstructedVal = initData.roles.some(
    (role: { codigo: string }) =>
      role.codigo === "APROC" || role.codigo === "CONFOC",
  );

  const subroganteVal =
    !!initData?.mi_subrogancia && initData?.mi_subrogancia?.trim().length > 0
      ? true
      : false;

  const fetchOrdenesCompra = async () => {
    const responseGetOrdenes = await api.GET_ORDENES_COMPRA.getOrdenesCompra(
      initData.id,
      initData.id_centro_costo,
      contextmenu,
      initData.centros_costo_vista,
      rolesDeconstructedVal,
      subroganteVal,
    );

    if (responseGetOrdenes !== null) {
      ordenesCompra.current = responseGetOrdenes;
      const responseGetOrdenesCompraDetails =
        await api.GET_ORDENES_COMPRA_DETALLES.getOrdenesCompraDetalle();
      if (responseGetOrdenesCompraDetails !== null) {
        ordenesCompraDetalles.current = responseGetOrdenesCompraDetails;
        //MERGE ARRAYS
        let parent: Array<any> = ordenesCompra.current as unknown as Array<any>;
        let detalle: Array<any> =
          ordenesCompraDetalles.current as unknown as Array<any>;

        function callback(obj: any) {
          const childs = detalle?.filter(
            (childObj: any) =>
              childObj["ocdet_id_orden_compra"] === obj["oc_id"],
          );

          let childArray = [];
          if (obj.detalle !== undefined) {
            childArray = obj.detalle;
          }

          /*const childsConMoneda = childs.map((child) => ({
            ...child,
            tipmon_id: obj.tipmon_id, // <--- Aquí ocurre la magia
          })); DUPLICA ACTUALMENTE DETALLES */

          childArray = [...childArray, ...childs];

          // childArray = [...childArray, ...childsConMoneda];

          const textoBusqueda =
            `${obj.nombres || ""} ${obj.apellidos || ""} ${obj.cc_nombre || ""}`.toLowerCase();

          const socIdsCombinados = childArray
            .map((c: any) => c.soc_id) // Usamos el campo real que mencionas
            .filter(
              (value, index, self) => value && self.indexOf(value) === index,
            ) // Quitamos nulos y duplicados
            .join(", ");

          const aprobadoresCombinados = childArray
            .map((c: any) => c.suda_nombre_usuario) // Usamos el campo real que mencionas
            .filter(
              (value, index, self) => value && self.indexOf(value) === index,
            ) // Quitamos nulos y duplicados
            .join(", ");

          // Centros de costo destino: los de las lineas de detalle (sdetcc),
          // no el del solicitante. Texto "id - nombre" sin duplicados.
          const centrosCostoDestino = childArray
            .map((c: any) =>
              c.sdetcc_id || c.sdetcc_nombre
                ? `${c.sdetcc_id ?? ""} - ${String(c.sdetcc_nombre ?? "").trim()}`
                : null,
            )
            .filter(
              (value, index, self) => value && self.indexOf(value) === index,
            )
            .join(" | ");

          const filtroEspecialPreciosMonedas = {
            precios: childs.map((c) => parseFloat(c.ocdet_precio_total) || 0),
            moneda: obj.tipmon_id,
            estadoGeneral: obj.ocest_id,
            id: obj.oc_id,
          };
          return {
            ...obj,
            detalle: childArray,
            busqueda_solicitante: textoBusqueda,
            soc_id: socIdsCombinados,
            aprobadores_combinados: aprobadoresCombinados,
            ocdet_precio_total: filtroEspecialPreciosMonedas,
            centros_costo_destino: centrosCostoDestino,
          };
        }
        const result = parent ? parent.map(callback) : [];

        setData(result);

        setNeedFetchingDoc(false);
      } else {
        showMsg(
          toast,
          "danger",
          "Error",
          "Error capturando datos de detalle de orden de compra",
        );
      }
    } else {
      showMsg(
        toast,
        "danger",
        "Error",
        "Error capturando datos de orden de compra",
      );
    }
  };

  useEffect(() => {
    if (!needFetchingDoc) return;
    // La primera carga (exitosa o no) termina el estado "cargando datos"
    fetchOrdenesCompra().finally(() => setCargandoDatos(false));
  }, [needFetchingDoc]);

  const fetchDatosAprobacionesConfirmaciones = async (
    idOrdenCompra: number,
  ) => {
    const responseGetOrdenesStatesApproval =
      await api.GET_ORDENES_COMPRA_APPROVALS_STATES.getOrdenesCompraApprovalStates(
        idOrdenCompra,
      );
    if (responseGetOrdenesStatesApproval !== null) {
      ordenesCompraApprovalStates.current = responseGetOrdenesStatesApproval;

      //RECUPERACION INMEDIATA
      return responseGetOrdenesStatesApproval;
    } else {
      showMsg(
        toast,
        "danger",
        "Error",
        "Ha ocurrido un error capturando los datos de estados de la orden de compra",
      );
    }
  };

  const fetchDatosFirmaAprobacionesConfirmaciones = async (idOrden: number) => {
    const responseGetSignOrdersStatesApproval =
      await api.GET_SIGN_ORDER_HISTORY.getSignOrderHistory(idOrden);
    if (responseGetSignOrdersStatesApproval !== null) {
      ordenesSignApprovalHistory.current = responseGetSignOrdersStatesApproval;

      //RECUPERACION INMEDIATA
      return responseGetSignOrdersStatesApproval;
    } else {
      showMsg(
        toast,
        "danger",
        "Error",
        "Ha ocurrido un error capturando los datos de firma historia de la orden",
      );
    }
  };

  const fetchDatosProveedorById = async (idProveedor: number) => {
    const responseGetDataProveedor =
      await api.GET_DATOS_PROVEEDORES_BY_ID.getDataProveedorById(idProveedor);
    if (
      responseGetDataProveedor !== null &&
      responseGetDataProveedor !== undefined &&
      Object.keys(responseGetDataProveedor).length !== 0
    ) {
      dataProveedor.current = responseGetDataProveedor;
      return responseGetDataProveedor;
    } else {
      showMsg(
        toast,
        "danger",
        "Error",
        "Ha ocurrido un error capturando los datos del proveedor",
      );
      return null;
    }
  };

  const getPptoDisponibleValida = async (
    idCentroCosto: number,
    idItem: number,
    numeroLinea: number,
    mesGastoId: number,
  ) => {
    //ESTE DE PPTO PUEDE SER MIGRADO A CONTEXT EN UN SOLO LLAMADO PARA TODAS LAS CUENTAS Y SU PRESUPUESTO POR CENTRO
    const responseGetPptoDisponible =
      await api.GET_PPTO_DISPONIBLE_CC.getPptoCentroCosto(
        initData.id,
        idCentroCosto,
        idItem,
      );
    if (responseGetPptoDisponible !== null) {
      /*console.log(
        "PPTO DISPONIBLE: ",
        JSON.stringify(responseGetPptoDisponible),
      );*/
    } else {
      return "error";
    }

    const responseGetPptoTomadoCentro =
      await api.GET_PPTO_TOMADO_CC.getPptoTomadoCentroCosto(
        initData.id,
        idCentroCosto,
        mesGastoId,
        idItem,
      );

    if (responseGetPptoTomadoCentro !== null) {
      /* console.log("PPTO TOMADO: ", JSON.stringify(responseGetPptoTomadoCentro));*/

      let sumPresupuestoDisponibleCentro = 0;
      for (var x = 1; x <= mesGastoId; x++) {
        switch (x) {
          case 1:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.enero;
            break;
          case 2:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.febrero;
            break;
          case 3:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.marzo;
            break;
          case 4:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.abril;
            break;
          case 5:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.mayo;
            break;
          case 6:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.junio;
            break;
          case 7:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.julio;
            break;
          case 8:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.agosto;
            break;
          case 9:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.septiembre;
            break;
          case 10:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.octubre;
            break;
          case 11:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.noviembre;
            break;
          case 12:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.diciembre;
            break;
          default:
        }
      }

      let totalValueLine =
        (
          document.getElementById(`os_precio_unitario_total_0`)
            ?.children[0] as HTMLInputElement
        )?.value ?? "0";

      let errorElement = document.getElementById(
        `ppto_error_${numeroLinea}`,
      ) as HTMLInputElement;

      let presupuestoTomadoTotalCc =
        responseGetPptoTomadoCentro.total +
        parseNumberCommaFormatForOperations(totalValueLine);

      /*console.log(
        "CHECK sumPresupuestoDisponibleCentro: ",
        sumPresupuestoDisponibleCentro,
      );
      console.log(
        "CHECK presupuestoSolicitadoTotalCc: ",
        presupuestoTomadoTotalCc,
      );*/
      //VALIDACIONES DE RETORNO
      if (sumPresupuestoDisponibleCentro < presupuestoTomadoTotalCc) {
        errorElement.innerText = "Sobrepasa el presupuesto disponible";
        return "#ff6767";
      }

      if (
        sumPresupuestoDisponibleCentro > presupuestoTomadoTotalCc &&
        presupuestoTomadoTotalCc > (sumPresupuestoDisponibleCentro * 90) / 100
      ) {
        errorElement.style.color = "#cdca6d";
        errorElement.innerText = "Has superado el 90% del presupuesto";
        return "yellow";
      } else {
        errorElement.style.color = "#000000";
        errorElement.innerText = "Presupuesto disponible";
        return "#FFFFFF";
      }
    } else {
      return "error";
    }
  };

  //**************************** VARIABLES Y ESTADOS *******************************/
  const [data, setData] = useState<any>([]);
  const [expandedRows, setExpandedRows] = useState<
    DataTableExpandedRows[] | undefined
  >(undefined);
  interface RowData {
    ocdet_id: string;
    ocdet_cantidad?: string;
    sdetcc_id?: number;
    sdetcc_nombre?: string;
    item_id?: number;
    item_nombre?: string;
    ocdet_precio_unitario?: string;
    ocdet_precio_total?: string;
    ocdet_observaciones?: string;
    archivos?: string;
    ocest_id?: number;
    ocest_nombre?: string;
    soc_id?: number;
  }

  const [selectedRow, setSelectedRow] = useState<RowData | null>(null);
  const [selectedCentroCostoId, setSelectedCentroCostoId] = useState<number>(
    selectedRow?.sdetcc_id ? selectedRow?.sdetcc_id : 0,
  );
  const [selectedCentroCosto, setSelectedCentroCosto] = useState<string>(
    selectedRow?.sdetcc_nombre ? selectedRow?.sdetcc_nombre : "Seleccione...",
  );

  const [jsonDataEditDetalle, setJsonDataEditDetalle] = useState({});
  const [metaKey, setMetaKey] = useState(true);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [dialogPdfVisible, setDialogPdfVisible] = useState(false);
  const [dialogEditaDetalleVisible, setDialogEditaDetalleVisible] =
    useState(false);
  const [dialogEditaEstadoOc, setDialogEditaEstadoOc] = useState(false);

  FilterService.register("custom_detail_proveedor_filter", (value, filter) => {
    // 1. If user hasn't typed anything, show everything
    if (!filter || filter.trim() === "") return true;

    // 2. 'value' is now correctly row.detalle
    if (!value || !Array.isArray(value)) return false;

    return value.some((item: any) => {
      // IMPORTANT: Verify 'prov_nombre' exists inside these objects
      const nombre = item.prov_nombre
        ? String(item.prov_nombre).toLowerCase()
        : "";
      return nombre.includes(filter.toLowerCase());
    });
  });

  FilterService.register("custom_detail_aprobador_filter", (value, filter) => {
    // 1. Si el usuario no ha escrito nada, mostramos todo
    if (!filter || filter.trim() === "") return true;

    // 2. 'value' aquí recibe directamente tu string "aprobadores_combinados"
    if (!value) return false;

    // 3. Simplemente verificamos si el texto ingresado está dentro del string de aprobadores
    return String(value).toLowerCase().includes(filter.toLowerCase());
  });

  FilterService.register(
    "custom_detail_precio_total_filter",
    (value, filter) => {
      // 1. Si no hay filtro de búsqueda ingresado, mostrar todo
      if (filter === null || filter === undefined || filter === "") {
        return true;
      }

      const threshold = Number(filter);
      if (isNaN(threshold)) return true;

      // 2. Validación estructural preventiva
      if (!value || value.montoTotalNeto === undefined) {
        return true; // No bloqueamos la fila si los datos de la API aún no cargan
      }

      const monedaId = Number(value.moneda);
      const precioBase = Number(value.montoTotalNeto);

      if (isNaN(precioBase)) return false;

      let precioConvertido = precioBase;

      // 3. Aplicamos el multiplicador correspondiente sobre la SUMA TOTAL
      switch (monedaId) {
        case 2: // Dólar
          precioConvertido = precioBase * 930;
          break;
        case 3: // Euro
          precioConvertido = precioBase * 1070;
          break;
        case 40: // UF
          precioConvertido = precioBase * 40900;
          break;
        default: // Pesos u otros
          precioConvertido = precioBase;
          break;
      }

      console.log(
        `OC N° ${value.id} - Suma Total Neta: ${precioBase} -> Convertido: ${precioConvertido} (Umbral: ${threshold})`,
      );

      // 4. Retornamos si la OC completa supera el monto del filtro
      return precioConvertido > threshold;
    },
  );

  const [filters, setFilters] = useState<{
    [key: string]: { value: string | null; matchMode: FilterMatchMode };
  }>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    tipmon_nombre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subdoc_nombre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    soc_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    oc_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    busqueda_solicitante: { value: null, matchMode: FilterMatchMode.CONTAINS },
    cc_nombre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    oc_dt_cre: {
      value: searchParams.get("oc_dt_cre") || null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    ocest_nombre: {
      value: searchParams.get("ocest_nombre") || null,
      matchMode: FilterMatchMode.EQUALS,
    },
    detalle: {
      value: null,
      matchMode: "custom_detail_proveedor_filter" as any,
    },
    aprobadores_combinados: {
      value: null,
      matchMode: "custom_detail_aprobador_filter" as any,
    },
    estope_nombre: {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    ocdet_precio_total: {
      value: searchParams.get("ocdet_precio_total") || null,
      matchMode: "custom_detail_precio_total_filter" as any,
    },
    // Filtro "Centro Costo Destino" (cabecera de la tabla)
    centros_costo_destino: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [isLoading, setIsLoading] = useState(true);
  // Hasta que llega la primera carga de datos se muestra "Cargando..." en
  // lugar de la tabla (isLoading se apaga apenas se renderiza)
  const [cargandoDatos, setCargandoDatos] = useState(true);
  // Same 20px on every side: the app shell is 100vw wide, so the
  // scrollbar width is added back on the right (--rp-scrollbar-width)
  useScrollbarGutter();
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const areaRef = useRef<HTMLTextAreaElement>(null);
  const toast = useRef(null);
  const dt = useRef<DataTable<typeof data> | null>(null);
  const getTiposEstado = (status: any) => {
    switch (status) {
      case "Anulada":
        return "var(--color-anuladas)";
      case "Aprobada":
        return "var(--color-aprobadas)";
      case "Pendiente":
        return "var(--color-pendiente)";
      case "Rechazada":
        return "var(--color-rechazadas)";
      case "Rechazada parcialmente":
        return "var(--color-rechazadas-parcial)";
      case "Aprobada parcialmente":
        return "var(--color-aprobadas-parcial)";
      case "Confirmada":
        return "var(--color-confirmadas)";
      case "Confirmada parcialmente":
        return "var(--color-confirmadas-parcial)";
      case "Pendiente GG":
        return "var(--color-pendientes-gte)"; // Corregido: plural según tus CSS comments
      case "Confirmada GG":
      case "Confirmadas GG":
        return "var(--color-confirmadas-gte)";
      default:
        return "var(--primary-color)"; // Color por defecto (gris o primario)
    }
  };

  //ESTADOS DE NUEVO DETALLE A CREAR
  const [newDetailDialog, setNewDetailDialog] = useState(false);
  const [submittedNewDetail, setSubmittedNewDetail] = useState(false);
  const [newDetalle, setNewDetalle] = useState(emptyNewDetaille);
  const [deleteNewDetailDialog, setDeleteNewDetailDialog] = useState(false);
  const [deleteNewDetailsDialog, setDeleteNewDetailsDialog] = useState(false);
  const [showModalConfirmNewDetail, setShowModalConfirmNewDetail] =
    useState(false);

  const hideNewDialog = () => {
    setSubmittedNewDetail(false);
    setNewDetailDialog(false);
  };

  const [editDetalleDialog, setEditDetalleDialog] = useState(false);
  const [deleteDetalleDialog, setDeleteDetalleDialog] = useState(false);
  const [showDialogDownloadFiles, setShowDialogDownloadFiles] = useState(false);
  const ref = useRef<any>(null);
  const [showModalFirma, setShowModalFirma] = useState(false);
  const lastPriceItemSelected = useRef<any[]>([]);

  useEffect(() => {
    if (data.length || needFetchingDoc) return;
    setNeedFetchingDoc(true);
  }, [data]);
  /******************************** CRUD DE DETALLES SOLICITUDES ******************************/

  const openNew = () => {
    //setProduct(emptyProduct);
    //setSubmitted(false);
    setEditDetalleDialog(true);
  };

  const hideEditDetalleDialog = () => {
    //setSubmitted(false);
    setEditDetalleDialog(false);
  };

  /*const editProduct = (product) => {
        setProduct({ ...product });
        setProductDialog(true);
    };

    const confirmDeleteProduct = (product) => {
        setProduct(product);
        setDeleteProductDialog(true);
    };

    const deleteProduct = () => {
        let _products = products.filter((val) => val.id !== product.id);

        setProducts(_products);
        setDeleteProductDialog(false);
        setProduct(emptyProduct);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
    };*/

  //*******************************************************************************************/

  /******************************** EXPORT DOCUMENTS *********************************/

  {
    /* const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));*/
  }

  const exportCSV = (selectionOnly: any) => {
    if (dt.current) {
      dt.current.exportCSV({ selectionOnly });
    }
  };

  /*const exportPdf = () => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                (doc as any).autoTable({
                    head: [exportColumns.map(col => col.title)],
                    body: data.map(item => exportColumns.map(col => item.detalle[col.dataKey])),
                });
                doc.save('products.pdf');
            });
        });
    };*/

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      // Generamos la fecha DDMMYYYY
      const today = new Date().toLocaleDateString("es-ES").split("/").join("");

      // ---------------------------------------------------------
      // 1. PREPARAR HOJA PRINCIPAL ("Cabecera OC")
      // ---------------------------------------------------------
      const dataConAlias = data.map((item: any) => ({
        "N° Orden": item.oc_id,
        "N° SOC": item.soc_id,
        "Estado Actual": item.ocest_nombre,
        "Fecha Creación": item.oc_dt_cre,
        "Tipo Orden": item.subdoc_nombre,
        "Solicitante OC": item.nombres + " " + item.apellidos,
        "Centro solicitante": item.cc_nombre,
        Proveedor: item.prov_nombre, // Agregué comillas por consistencia
        "Doc. Tributario": item.doctrib_nombre,
        "Tipo Moneda": item.tipmon_nombre, // Quité los dos puntos ":" del nombre de la columna (opcional)
        "Mes Presupuesto": item.meses_nombre,
        "Estado Operacional": item.estope_nombre,
        Aprobadores: item.aprobadores_combinados, // Agregué comillas por consistencia
        "Justificaciones/Observaciones": item.oc_observaciones, // Agregué comillas por consistencia
        "Tasa Cambio": item.tasa_cambio, // Agregué comillas por consistencia
        "Condición Pago": item.condpago_nombre,
      }));

      const worksheet = xlsx.utils.json_to_sheet(dataConAlias);

      // ---------------------------------------------------------
      // 2. PREPARAR HOJA DETALLE ("Detalles OC")
      // ---------------------------------------------------------
      const detallesConAlias = data
        .flatMap((item: any) => item.detalle || [])
        .map((det: any) => ({
          "N° Detalle": det.ocdet_id,
          "N° Orden": det.ocdet_id_orden_compra,
          "N° SOC Detalle": det.ocdet_id_solicitud_orden_compra_detalle,
          "Solicitante SOC": det.solicitante,
          "Solicitante SOC Centro": det.cc_solicitante,
          "Producto/Servicio": det.item_nombre,
          "Centro Costo": det.sdetcc_nombre,
          Cantidad: det.ocdet_cantidad, // Agregué comillas
          "Precio Unitario": det.ocdet_precio_unitario,
          "Precio Total": det.ocdet_precio_total,
          Estado: det.ocest_nombre, // Agregué comillas
          Glosa: det.ocdet_observaciones, // Agregué comillas
          Justificaciones: det.justificacion, // Agregué comillas
          "Fecha creación": det.ocdet_dt_cre,
        }));

      const worksheetDetail = xlsx.utils.json_to_sheet(detallesConAlias);

      // ---------------------------------------------------------
      // 3. GENERAR EL LIBRO (WORKBOOK)
      // ---------------------------------------------------------
      // CORRECCIÓN: Las claves deben coincidir EXACTAMENTE con los nombres del array
      const workbook = {
        Sheets: {
          "Cabecera OC": worksheet, // Antes decía 'data'
          "Detalles OC": worksheetDetail, // Antes decía 'detalle'
        },
        SheetNames: ["Cabecera OC", "Detalles OC"],
        Props: {},
      };

      // 4. ESCRIBIR Y GUARDAR
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array", // Recomendado para React/Web
      });

      saveAsExcelFile(excelBuffer, `Ordenes_Compra_${today}`);
    });
  };

  /*const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(data);

      const worksheetDetail = xlsx.utils.json_to_sheet(
        data.flatMap((item: any) => item.detalle || []),
      );

      const workbook = {
        Sheets: { data: worksheet, detalle: worksheetDetail },
        SheetNames: ["data", "detalle"],
        Props: {},
      };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };*/

  const saveAsExcelFile = (buffer: BlobPart, fileName: string) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
      }
    });
  };

  /************************************************************************************/
  /*************************** EVENTOS FUNCIONES *************************/

  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  // Filtro "Centro Costo Destino": centros de costo de las lineas de detalle
  const onCentroCostoDestinoChange = (value: string) => {
    setFilters((prev) => ({
      ...prev,
      centros_costo_destino: {
        value: value.trim() ? value : null,
        matchMode: FilterMatchMode.CONTAINS,
      },
    }));
  };

  const onFilterChange = (e: any) => {
    // 1. Actualiza el estado visual de la tabla
    setFilters(e.filters);

    // 2. Extrae el nuevo valor que el usuario seleccionó para el estado
    const newSocestValue = e.filters.socest_nombre?.value;

    // 3. Clona los parámetros actuales de la URL para no sobreescribir otros si los tuvieras
    const currentParams = new URLSearchParams(searchParams);

    // 4. Actualiza o elimina el parámetro en la URL
    if (newSocestValue) {
      currentParams.set("socest_nombre", newSocestValue);
    } else {
      currentParams.delete("socest_nombre");
    }

    // 5. Empuja la nueva URL al navegador
    setSearchParams(currentParams);
  };

  /********************************* TEMPLATES DE CELDAS *************************************/

  const singleFilterSolicCentroElement = (
    options: ColumnFilterElementTemplateOptions,
  ) => {
    return (
      <div className="flex flex-column gap-2">
        <InputText
          placeholder="Solicitante..."
          value={options.value || ""}
          // 👇 CAMBIO AQUÍ: Usar filterApplyCallback
          onChange={(e) => options.filterApplyCallback(e.target.value)}
        />
      </div>
    );
  };

  const filtroNombreOCentro = (
    value: any,
    filter: any,
    filterLocale: string,
    params: any,
  ) => {
    if (!filter) return true;

    const textoBusqueda = String(filter).toLowerCase();
    const fila = params?.rowData;

    if (!fila) return false;

    // 👇 Unimos el nombre y el apellido paterno
    const nombreCompleto =
      `${fila.nombres || ""} ${fila.apellidos || ""}`.toLowerCase();
    const coincideNombre = nombreCompleto.includes(textoBusqueda);

    const coincideCentro = String(fila.cc_nombre || "")
      .toLowerCase()
      .includes(textoBusqueda);

    return coincideNombre || coincideCentro;
  };

  const solicitanteFusionadoBodyTemplate = (rowData: any) => {
    // 1. Unimos el nombre y el apellido de forma segura (por si alguno viene nulo)

    const nombreCompleto = rowData.detalle
      .map((item: any) => `${item.solicitante || ""}`.trim())
      .filter(Boolean)
      .filter(
        (val: string, index: number, self: string[]) =>
          self.indexOf(val) === index,
      )
      .join(", ");

    const centrosSol = rowData.detalle
      .map((item: any) => `${item.cc_solicitante || ""}`.trim())
      .filter(Boolean)
      .filter(
        (val: string, index: number, self: string[]) =>
          self.indexOf(val) === index,
      )
      .join(", ");

    return (
      <div className="flex align-items-center gap-2">
        <img
          alt="solicitante"
          src={Avatar}
          style={{ width: "24px", height: "24px", paddingRight: "5px" }}
        />
        {/* 2. Mostramos el nombre completo arriba y el centro abajo */}
        <div className="flex flex-column">
          <div>
            <span className="font-bold">{nombreCompleto}</span>
          </div>
          <div>
            <span
              style={{
                fontSize: "0.6rem",
                fontWeight: 800,
              }}
              className="text-sm text-500"
            >
              {centrosSol}
            </span>
          </div>
        </div>
      </div>
    );
  };

  /*const solicitanteBodyTemplate = (rowData: any) => {
    return (
      <div className="flex align-items-center gap-2">
        <img
          width="20px"
          height="20px"
          alt="solicitante"
          src={Avatar}
          style={{ width: "24px", paddingRight: "5px" }}
        />
        <span>{rowData.nombres}</span>
      </div>
    );
  };*/

  const aprobadorBodyTemplate = (rowData: any) => {
    let usuarioAprobador = "";

    const aprobadores = rowData.detalle
      ? rowData.detalle
          .map((d: any) => d.suda_nombre_usuario) // Extraemos los nombres
          .filter(
            (nombre: string, index: number, self: string[]) =>
              nombre && self.indexOf(nombre) === index, // Filtramos duplicados y vacíos
          )
      : [];

    // 1. Unimos el nombre y el apellido de forma segura (por si alguno viene nulo)
    const nombreCompleto = `${aprobadores || ""}`.trim();

    return (
      <div className="flex align-items-center gap-2">
        <img
          alt="aprobador"
          src={Avatar}
          style={{ height: "24px", paddingRight: "5px" }}
        />
        {/* 2. Mostramos el nombre completo arriba y el centro abajo */}
        <div className="flex flex-column">
          <div>
            <span className="font-bold">{nombreCompleto}</span>
          </div>
        </div>
      </div>
    );
  };

  const mainProveedorTemplate = (rowData: any) => {
    const provs = rowData.detalle?.map((d: any) => d.prov_nombre);
    const uniqueProvs = [...new Set(provs)] as string[];

    if (uniqueProvs.length === 0) return <span>Sin proveedores</span>;
    if (uniqueProvs.length === 1) return <span>{uniqueProvs[0]}</span>;

    return (
      <span>
        {uniqueProvs[0]} (+{uniqueProvs.length - 1})
      </span>
    );
  };

  useEffect(() => {
    setIsLoading(false);
  });

  const archivoBodyTemplate = (data: any) => {
    const parts = data.oc_dt_cre.split("-");
    const mes = parts[1];
    const ano = parts[2];

    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        {initData.id_centro_costo === CENTRO_COSTO_ADQUISICION ? (
          <Button
            label={`SUBIR ANEXOS ↑`}
            className="btn-cinematic"
            onClick={() => setDialogVisible(true)}
          />
        ) : null}
        <DownloadFiles
          path={`ordenes/${ano}/${mes}/${data.oc_id}`}
          numDoc={data.oc_id}
          className="btn-cinematic"
          pdf={false}
        />
        {IS_MOBILE() ? (
          <ShowFilesRepo
            ordenCompra={data.oc_id}
            ano={ano}
            mes={mes}
          ></ShowFilesRepo>
        ) : null}

        {data.estope_id == 3 ? (
          <span style={{ fontSize: "0.7rem", margin: "0 1rem" }}>
            <b>Justificación Asignación directa: </b>
            {data.oc_observaciones}
          </span>
        ) : null}
      </div>
    );
  };

  //************************ ESTADO FUNCIONES FILTRO *********************/
  const estadoBodyTemplateSelected = (option: any) => {
    return (
      <Tag
        className="tagTable"
        value={option} // Aquí es option directo, no option.ocest_nombre
        style={{
          backgroundColor: getTiposEstado(option),
          color: "white", // Opcional: para asegurar que el texto se lea bien
        }}
      />
    );
  };

  const estadoBodyTemplate = (option: any) => {
    return (
      <div>
        <Tag
          className="tagTable"
          value={option.ocest_nombre}
          style={{
            backgroundColor: getTiposEstado(option.ocest_nombre),
            color: "white", // Opcional
          }}
          onClick={() => {
            //setDialogEditaEstadoOc(true);
          }}
        />
        <p style={{ color: "var(--primary-dark-color)" }}>
          {option.detalle?.[0]?.justificacion}
        </p>
      </div>
    );
  };

  const estadoRowFilterTemplate = (
    options: ColumnFilterElementTemplateOptions,
  ) => {
    const uniqueEstados = Array.from(
      new Set(data.map((item: { ocest_nombre: any }) => item.ocest_nombre)),
    );
    return (
      <Dropdown
        value={options.value}
        options={uniqueEstados}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={estadoBodyTemplateSelected}
        placeholder="Sel."
        className="p-column-filter"
        showClear
        style={{
          maxWidth: "8rem",
          marginBottom: "1rem",
          height: "2.5rem",
          marginLeft: "0",
        }}
      />
    );
  };

  /****************************** DIALOG MODAL ***************************/

  const dialogFooterTemplate = () => {
    return (
      <Button
        style={{ backgroundColor: "blue", width: "50px", height: "30px" }}
        label="Ok"
        onClick={() => {
          setDialogVisible(false);
          setDialogPdfVisible(false);
        }}
      />
    );
  };

  const handleQuantityChange = (value: number, index: number) => {
    const totalPrecioUni = value * selectedPrecioUnitarioRef;
    setSelectedPrecioTotalRef(totalPrecioUni);
  };

  const fetchLastPriceItemSelected = async (
    idItemSelected: number,
    idRow: number,
  ) => {
    //SE PUEDE INCORPORAR AVISO DE EXISTENCIA

    try {
      const responseGetLastPriceItem =
        await api.GET_LAST_PRICE_ITEM_SELECTED.getLastPriceItemSelected(
          idItemSelected,
        );
      if (responseGetLastPriceItem !== null) {
        lastPriceItemSelected.current[idRow] =
          responseGetLastPriceItem.ultimo_precio_unitario_neto;

        setselectedPrecioUnitarioRef(
          responseGetLastPriceItem.ultimo_precio_unitario_neto,
        );
        const cantidadElement = document.getElementById(`os_cantidad_${idRow}`)
          ?.childNodes[0] as HTMLFormElement;

        let cleanValue = cantidadElement.value
          .replace(/\./g, "")
          .replace(",", ".");

        let quantityRow = parseFloat(cleanValue);

        setSelectedPrecioTotalRef(
          responseGetLastPriceItem.ultimo_precio_unitario_neto * quantityRow,
        );
      }
    } catch (error) {
      setselectedPrecioUnitarioRef(0);
      setSelectedPrecioTotalRef(0);
      console.error("Error fetching last price item:", error);
    }
  };
  /***********************************************************************/

  /******************************* ROW EXPANSION PARA DETALLES DE SOLICITUD ************************/

  const onRowExpand = (event: any) => {
    /*const dataEdit = event.data;
    setSelectedMesGasto(dataEdit.meses_nombre);
    setSelectedMesGastoId(dataEdit.meses_id);
    setSelectedEStadoOp(dataEdit.estope_nombre);
    setSelectedEstadoOpId(dataEdit.estope_id);
    setSelectedTipoMoneda(dataEdit.tipmon_nombre);
    setSelectedTipoMonedaId(dataEdit.tipmon_id);
    setselectedTipoOrden(dataEdit.subdoc_nombre);
    setselectedTipoOrdenId(dataEdit.subdoc_id);
    setSelectedNumeroSolicitud(dataEdit.soc_id);
    setSelectedDetailRowId(dataEdit.socdet_id);
    setSelectedEstado(dataEdit.socest_nombre);
    setSelectedEstadoId(dataEdit.socest_id);*/
  };

  const onRowCollapse = (event: any) => {
    if (toast.current) {
      //toast.current.show({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
    }
  };

  const expandAll = () => {
    let _expandedRows: any = {};

    data.forEach((p: any) => {
      if (p.detalle.length > 0) {
        _expandedRows[`${p.oc_id}`] = true;
      }
    });

    setExpandedRows(_expandedRows);
  };

  const collapseAll = () => {
    setExpandedRows(undefined);
  };

  const toggleRow = (rowData: any) => {
    const isCurrentRowExpanded = expandedRows
      ? expandedRows[rowData.oc_id]
      : false;

    if (isCurrentRowExpanded) {
      //SE CIERRA EN EL EVENTO DE TOGGLE DE FILA EXPANDIDA
      let _expandedRows: any = {};
      _expandedRows[`${rowData.oc_id}`] = undefined;
      setExpandedRows(_expandedRows);
    } else {
      //SE ABRE EN EL EVENTO DE TOGGLE DE FILA CERRADA Y SE CIERRAN LAS OTRAS QUE PUEDAN ESTAR ABIERTAS
      let _expandedRows: any = {};

      data.forEach((p: any) => {
        if (p.detalle.length > 0 && p.oc_id === rowData.oc_id) {
          _expandedRows[`${p.oc_id}`] = true;
        } else {
          _expandedRows[`${p.oc_id}`] = undefined;
        }
      });
      setExpandedRows(_expandedRows);
    }
  };

  const togglerTemplate = (rowData: any) => {
    // Check if THIS specific row is expanded to determine the icon
    const isExpanded = expandedRows ? expandedRows[rowData.oc_id] : false;

    return (
      <Button
        icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className="p-button-text p-button-rounded p-button-plain"
        onClick={() => toggleRow(rowData)}
        aria-label={isExpanded ? "Collapse Row" : "Expand Row"}
      />
    );
  };

  const allowExpansion = (rowData: any) => {
    return rowData[0].detalle.length > 0;
  };

  /**** SECCION DE FUNCIONES DE ACTUALIZACION DE DROPDOWNS SEGUN SELECCION *******/

  const handleUpdateMesFromChild = (option: any) => {
    setSelectedMesGasto(option.nombre);
    setSelectedMesGastoId(option.id);
  };
  const handleUpdateCentroFromChild = (option: any) => {
    setSelectedCentroCosto(option.nombre);
    setSelectedCentroCostoId(option.id);
  };

  const handleUpdateItemFromChild = (option: any) => {
    setSelectedItem(option.nombre);
    setSelectedItemId(option.id);

    fetchLastPriceItemSelected(option.id, 0);
  };

  const handleUpdateProveedorFromChild = (option: any) => {
    setSelectedProveedor(option.nombre);
    setSelectedProveedorId(option.id);
  };

  const handleUpdateEstadoFromChild = (option: any) => {
    setSelectedEstado(option.nombre);
    setSelectedEstadoId(option.id);
  };

  const handlePrecioUnitarioChange = (value: number, index: number) => {
    const totalPrecioUni = selectedCantidad * value;
    setSelectedPrecioTotalRef(totalPrecioUni);
  };

  const handleUpdateTipoMonFromChild = (option: any) => {
    setSelectedTipoMoneda(option.nombre);
    setSelectedTipoMonedaId(option.id);
  };

  const handleUpdateCondicionPagoFromChild = (option: any) => {
    setSelectedCondicionPagoId(option.id);
    setSelectedCondicionPago(option.nombre);
  };

  const handleUpdateTipoDocTributarioFromChild = (option: any) => {
    setSelectedTipoDocTributarioId(option.id);
    setSelectedTipoDocTributario(option.nombre);
  };

  const handleUpdateEstadoOpeFromChild = (option: any) => {
    setSelectedEStadoOp(option.nombre);
    setSelectedEstadoOpId(option.id);
  };

  const handleUpdateTipoSolFromChild = (option: any) => {
    setSelectedTipoOrden(option.nombre);
    setSelectedTipoOrdenId(option.id);
    itemsFiltered.current = FILTER_ITEMS_BY_DOC_TYPE(
      itemsAdquisicion,
      option.id,
      tiposItemsAdquisicion,
    );
  };

  const fetchTipoCambioDiaParaTipoMoneda = (idTipoMoneda: number) => {
    let responseGetTipoCambio;

    if (idTipoMoneda === 2) {
      responseGetTipoCambio =
        api.GET_INDICADOR_CAMBIO_DOLAR_DIA.getIndicadorCambioDolarDia();
    } else if (idTipoMoneda === 3) {
      responseGetTipoCambio =
        api.GET_INDICADOR_CAMBIO_EURO_DIA.getIndicadorCambioEuroDia();
    } else if (idTipoMoneda === 40) {
      responseGetTipoCambio =
        api.GET_INDICADOR_CAMBIO_UF_DIA.getIndicadorCambioUfDia();
    } else {
      //TIPO MONEDA PESOS
      responseGetTipoCambio = 1;
    }

    if (responseGetTipoCambio !== null) {
      return responseGetTipoCambio;
    } else {
      showMsg(
        toast,
        "danger",
        "Error",
        "Ha ocurrido un error capturando los datos de estados de la orden",
      );
      return "Ha ocurrido un error";
    }
  };

  const handleGeneratePdfOcEmited = async (
    dataOrden: any,
    ano: any,
    mes: any,
  ) => {
    try {
      // 1. Get the data
      const resAprobaciones = await fetchDatosAprobacionesConfirmaciones(
        dataOrden.oc_id,
      );
      const resFirmas = await fetchDatosFirmaAprobacionesConfirmaciones(
        dataOrden.oc_id,
      );
      const resProveedor = await fetchDatosProveedorById(dataOrden.prov_id);

      // -----------------------------------------------------------
      // FIX: MERGE SIGNATURES INTO APPROVAL STATES
      // The PDF generator expects 'ordenesApprovalStates' to contain the '.firma' property.
      // We map over 'resAprobaciones' and find the matching signature from 'resFirmas'.
      // -----------------------------------------------------------
      const mergedApprovalStates = (resAprobaciones ?? []).map(
        (approval: any, index: number) => {
          // OPTION A: If the arrays are in the exact same order (index 0 matches index 0)
          const matchingFirma = resFirmas && resFirmas[index];

          // OPTION B: If they share an ID (e.g., user_id or request_id), use .find() instead:
          // const matchingFirma = resFirmas.find(f => f.usuario_id === approval.usuario_id);

          return {
            ...approval,
            // Ensure we get the base64 string.
            // Check if your API returns it as 'firma', 'sign_file', or 'ufdh_firma'
            firma: matchingFirma
              ? matchingFirma.firma || matchingFirma.ufdh_firma
              : null,
          };
        },
      );

      if (resProveedor) {
        // 2. Pass the MERGED array to the PDF creator
        const fileBlob = await CreatePdfTableOrdenesBlob({
          data: dataOrden,
          initData: initData,
          ordenesApprovalStates: ordenesCompraApprovalStates.current ?? [], // <--- USE THE MERGED ARRAY
          solicitudesSignApprovalHistory:
            ordenesSignApprovalHistory.current ?? [],
          dataProveedor: resProveedor ?? {},
          parametros: parametros,
        });

        // 3. Upload the file
        const respuestaUpload = await api.FILE_UPLOAD_ORDER.fileBlobUploadOrder(
          fileBlob,
          ano,
          mes,
          "ordenes",
          dataOrden.oc_id,
        );
      }
    } catch (error) {
      console.error("Error in process:", error);
    }
  };

  const saveOrdenEdition = () => {
    const jsonObj: any = {
      id: selectedNumeroOrdenCompra,
      tiposolicitud: selectedTipoOrdenId,
      mesgasto: selectedMesGastoId,
      estadooperacional: selectedEstadoOpId,
      tipomoneda: selectedTipoMonedaId,
      idusuariosolicitante: initData.id,
      idproveedor: selectedProveedorId,
      tipocambiodia: 1, //fetchTipoCambioDiaParaTipoMoneda(selectedTipoMonedaId),
      estadosolicitud: 1,
      idtipodoctributario: selectedTipoDocTributarioId,
      condicionPago: selectedCondicionPagoId,
      detalles: [],
    };

    let detallesDivText = document.getElementById("os_detalles_0")?.innerHTML;

    if (
      selectedTipoOrdenId === 0 ||
      selectedMesGastoId === 0 ||
      selectedEstadoOpId === 0 ||
      selectedTipoMonedaId === 0
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Deben ser seleccionados todos los datos de cabecera de la orden",
      );
    } else {
      const precioUnitario = document.getElementById(`os_precio_unitario_0`)
        ?.childNodes[0] as HTMLFormElement;

      const precioUnitarioTotal = document.getElementById(
        `os_precio_unitario_total_0`,
      )?.childNodes[0] as HTMLFormElement;

      const jsonDetalleObj: any = {
        id: selectedDetailRowId,
        idoc: selectedNumeroOrdenCompra,
        cantidad: selectedCantidad.toString(),
        item: selectedItemId,
        centrocosto: selectedCentroCostoId,
        preciounitario: precioUnitario.value,
        preciounitariototal: precioUnitarioTotal.value,
        detalles: (detallesDivText ?? selectedDetalles.current) || "",
      };

      jsonObj.detalles.push(jsonDetalleObj);

      //CAPTURA ESPECIAL DE ULTIMA FILA PARA VALIDAR ANTES DE REGISTRAR
      if (selectedCantidad == 0) {
        showMsg(toast, "warn", "Advertencia", "Debe ingresar una cantidad");
      } else if (selectedItem == "") {
        showMsg(toast, "warn", "Advertencia", "Debe ingresar un item");
      } else if (selectedCentroCosto == "") {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar un centro de costo",
        );
      } else if (selectedPrecioUnitarioRef == 0) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar un precio unitario",
        );
      } else if (selectedPrecioTotalRef == 0) {
        showMsg(toast, "warn", "Advertencia", "El total debe ser mayor a 0");
      } else if (
        (selectedEstadoId == 4 || selectedEstadoId == 2) &&
        !VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT(detallesDivText)
      ) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Solo puedes ingresar en los detalles adicionales (glosas) letras, números, puntos, comas, guión o guión bajo, no se permiten espacios al final ni saltos de línea con enter.",
        );
      } else {
        setShowModalConfirm(true);

        setJsonDataOrdenCompra(jsonObj);
      }
    }
  };

  const formatCurrency = (value: any, tipmonId?: number) => {
    const decimals = tipmonId === 1 ? 0 : 2;

    return (Number(value) || 0).toLocaleString("de-DE", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };

  const precioUniBodyTemplate = (rowData: any) => {
    // Pass rowData.tipmon_id or data.tipmon_id depending on where it's stored
    return formatCurrency(rowData.ocdet_precio_unitario, data.tipmon_id);
  };

  const precioTotBodyTemplate = (rowData: any) => {
    return formatCurrency(rowData.ocdet_precio_total, data.tipmon_id);
  };

  const handleUpdateJustificacion = (e: any) => {
    if (selectedJustificacion.current == e.target.innerHTML) {
    } else {
      selectedJustificacion.current = e.target.innerHTML;
    }
  };

  const sendNewApprovalStateOrden = async (dataOrden: any) => {
    setShowModalLoadSpinner(true);

    setLoadingMessage("Registrando estado en el servidor...");

    const justificacionText =
      document.getElementById("os_justificacion")?.innerHTML;
    const idDetalle = selectedRow?.ocdet_id;

    const userIp = await getUserIp();

    const objApprovalState = {
      id_orden_compra: dataOrden.oc_id,
      id_orden_compra_detalle: idDetalle,
      id_orden_compra_estado: selectedEstadoId,
      id_usuario_aprobador: initData.id,
      observaciones: justificacionText,
      ip_registro: userIp,
      dt_cre: new Date(),
      dt_mod: new Date(),
    };

    if (selectedEstadoId == 0) {
      showMsg(toast, "warn", "Advertencia", "Debes seleccionar el estado");
      setShowModalLoadSpinner(false);
    } else if (
      (selectedEstadoId == 4 || selectedEstadoId == 2) &&
      (justificacionText?.length ?? 0) < 4
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe ingresar justificaciones al seleccionar estado de rechazo o anulación",
      );
      setShowModalLoadSpinner(false);
    } else if (
      (selectedEstadoId == 4 || selectedEstadoId == 2) &&
      !VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT(justificacionText)
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Sólo puedes ingresar en justificaciones letras, números, puntos, comas, guión o guión bajo.",
      );
      setShowModalLoadSpinner(false);
    } else if (
      (selectedEstadoId == 10 || selectedEstadoId == 6) &&
      selectedRow?.ocest_id == 6
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "No puedes seleccionar estado de confirmación gerencia o aprobación si la orden de compra se encuentra en estado aprobada.",
      );
      setShowModalLoadSpinner(false);
    } else if (
      (selectedEstadoId == 8 || selectedEstadoId == 6) &&
      selectedRow?.ocest_id == 9
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "No puedes seleccionar estado de confirmación o aprobación si la orden de compra se encuentra en estado Pendiente GG",
      );
      setShowModalLoadSpinner(false);
    } else {
      const responseSaveNewStateOrden =
        await api.POST_ORDENES_COMPRA_APPROVAL_STATE.sendOrdenCompraApprovalState(
          Number(idDetalle),
          JSON.stringify(objApprovalState),
        );

      if (responseSaveNewStateOrden !== null) {
        //console.log("SE REGISTRO EL NUEVO ESTADO DE LA ORDEN DE COMPRA");
        setLoadingMessage(
          "Registrando historia de firma y enviando notificaciones...",
        );
        //REGISTRAMOS HISTORIAL DE APROBACION DE FIRMA CON NUEVO CODIGO VALIDADOR
        //console.log("OBJETO APROBACION ESTADO: ", responseSaveNewStateOrden);
        let objApprovalSignHis = {
          id_usuario: initData.id,
          id_orden_compra: dataOrden.oc_id,
          id_orden_aprobacion_his: responseSaveNewStateOrden.id,
          id_algoritmo: self.crypto.randomUUID().toString().substring(0, 15),
          id_algoritmo_dos: "",
          dt_cre: new Date(),
        };

        try {
          const responseSaveNewSignHisApprovalOrden =
            await api.SEND_NEW_APPROVAL_SIGN_HIS_ORDER.sendNewApprovalSignHisOrder(
              JSON.stringify(objApprovalSignHis),
            );

          //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
          const responseEmailsDestinatarios =
            await api.GET_EMAILS_DESTINATARIES_ORD.getEmailsDestinatariesOrd(
              dataOrden.oc_id,
              Number(idDetalle),
              selectedEstadoId == 6
                ? "APROBACION"
                : selectedEstadoId == 8
                  ? "CONFIRMACION"
                  : selectedEstadoId == 10
                    ? "CONFIRMACION"
                    : selectedEstadoId == 4
                      ? contextmenu == "aprueba"
                        ? "APROBACION"
                        : contextmenu == "confirma"
                          ? "CONFIRMACION"
                          : "CREACION"
                      : "CREACION",
            );

          if (
            responseSaveNewSignHisApprovalOrden !== null &&
            responseEmailsDestinatarios.length > 0
          ) {
            responseEmailsDestinatarios.push(initData.email);

            if (appEnv === "production") {
              //console.log('OBJETO SIGN HIS APPROVE: ', responseSaveNewSignHisApprovalOrden)
              //ENVIAMOS MAIL DE NOTIFICACION DE CAMBIO DE ESTADO DE SOLICITUD DE ORDEN DE COMPRA
              let paramApruebaOcNt = parametros.find(
                (param: { codigo: string }) => param.codigo === "APROCNT",
              )?.valor;

              if (paramApruebaOcNt == 0) {
                if (selectedEstadoId == 4) {
                  //APRUEBA , se envía al creador y a los que tienen permiso de aprobar en la orden
                  //RECHAZA, se envía al creador y a los que tienen permiso de aprobar en la orden
                  //ANULA, se envía al creador y a los que tienen permiso de aprobar en la orden
                  //CONFIRMA, se envía al creador, a los que tienen permiso de confirmar en la orden
                  //26-10-2026 se avisaba al confirmar GG por este mail y solo se deja rechazo, dejando como aviso la emision en si
                  //SOLO SE AVISA AL RECHAZAR DESDE 10-03-26
                  let objMailUpdateOrdenState = {
                    from: "noreply@salmonesdechile.com",
                    subjectEmail: `Se ha actualizado la orden de compra N° ${dataOrden.oc_id} en su detalle N° ${idDetalle}, con el estado: ${selectedEstado}, correspondiente al centro de costo: ${selectedRow?.sdetcc_nombre}`,
                    sendTo: responseEmailsDestinatarios.join(","),
                    cc: responseEmailsDestinatarios.includes(
                      "magdalena.delgado@salmonesdechile.com",
                    )
                      ? "OCOPERACIONES@salmonesdechile.com, sistemas.ti@salmonesdechile.com"
                      : "sistemas.ti@salmonesdechile.com",
                    template: "nuevoEstadoOrdenCompra",
                    nroOrden: dataOrden.oc_id,
                    usuario:
                      initData.nombres !== undefined
                        ? initData.nombres + " " + initData.apellido_paterno
                        : "solicitante sin nombres",
                    centroCosto: selectedRow?.sdetcc_nombre,
                    estado: selectedEstado,
                    nroDetalle: idDetalle,
                  };

                  //SE ENVIA MAIL DE NOTIFICACION DE CAMBIO DE ESTADO A LOS USUARIOS INTERNOS
                  await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                    JSON.stringify(objMailUpdateOrdenState),
                  );
                }

                if (
                  selectedEstadoId == 1 &&
                  USUARIO_CONFIRMA_GTE_GENERAL.includes(initData.id)
                ) {
                  justificacionText;
                  let objMailUpdateOrdenState = {
                    from: "noreply@salmonesdechile.com",
                    subjectEmail: `Gerencia ha comentado: ${justificacionText}. OC N° ${dataOrden.oc_id}.`,
                    sendTo: responseEmailsDestinatarios.join(","),
                    cc: "sistemas.ti@salmonesdechile.com",
                    template: "nuevoEstadoOrdenCompra",
                    nroOrden: dataOrden.oc_id,
                    usuario:
                      initData.nombres !== undefined
                        ? initData.nombres + " " + initData.apellido_paterno
                        : "solicitante sin nombres",
                    centroCosto: selectedRow?.sdetcc_nombre,
                    estado: selectedEstado,
                    nroDetalle: idDetalle,
                  };

                  //SE ENVIA MAIL DE NOTIFICACION DE CAMBIO DE ESTADO A LOS USUARIOS INTERNOS
                  await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                    JSON.stringify(objMailUpdateOrdenState),
                  );
                }
              }
            }
          }

          /*console.log(
            "SE REGISTRO EL REGISTRO HISTORICO DE FIRMA Y SE ENVIO EL MAIL DE CAMBIO DE ESTADO",
          );*/

          //console.log("SE INTENTA VALIDAR LA OC N° ", dataOrden.oc_id);
          //VALIDATE OC IS CONFIRMED
          let responseValidateOrdenStateConfirmed =
            await api.GET_ORDEN_COMPRA_BY_ID.getOrdenCompraById(
              dataOrden.oc_id,
            );

          /*console.log(
            "SE VALIDÓ EL ESTADO DE LA ORDEN DE COMPRA: ",
            responseValidateOrdenStateConfirmed,
          );*/
          if (responseValidateOrdenStateConfirmed !== null) {
            ordenConfirmedForInet.current = responseValidateOrdenStateConfirmed;
            //SE VALIDA EL MONTO DE LA ORDEN PARA PARTICIPAR EL GERENTE
            let montoFirmaGte = parametros.find(
              (param: { codigo: string }) => param.codigo === "OC_FIR_GTE",
            )?.valor;
            //CONFIRMADA SE GUARDA LA ORDEN EN REPOSITORIO Y SE ENVIA A PROVEEDOR
            //SI LA ORDEN TIENE MONTOS ACUMULADOS DE SUS DETALLES MENORES AL PARAMETRO O LA ORDEN HA PASADO A ESTADO 10 (CONFIRMADA GTE) ENTRAMOS

            /* console.log(
              "CHECK PRIMER VALOR DE VALIDACION ANTES DE ENTRAR EN SECCION PROVEEDOR OC: ",
              responseValidateOrdenStateConfirmed.detalle.reduce(
                (acum: any, item: { ocdet_precio_total: number }) =>
                  acum + item.ocdet_precio_total,
                0,
              ),
            );*/

            /*const totalValidado =
                responseValidateOrdenStateConfirmed.detalle.reduce(
                  (
                    acum: number,
                    item: { ocdet_precio_total: number; ocest_id: number }
                  ) =>
                    item.ocest_id === 8 &&
                    item.ocdet_precio_total < montoFirmaGte
                      ? acum + item.ocdet_precio_total // If true, add to total
                      : acum, // If false, keep previous total
                  0
                );*/

            //ACTUALIZADO
            const totalValidado =
              responseValidateOrdenStateConfirmed.detalle.reduce(
                (
                  acum: number,
                  item: { ocdet_precio_total: number; ocest_id: number },
                ) =>
                  item.ocest_id === 8
                    ? acum + item.ocdet_precio_total // Add if ID is 8
                    : acum, // Skip otherwise
                0,
              );

            /*console.log(
              "responseValidateOrdenStateConfirmed.oc_id_estado_orden: ",
              responseValidateOrdenStateConfirmed.oc_id_estado_orden,
            );*/
            /*console.log(
              "VAL NO SIG CEO: ",
              VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
                totalValidado,
                montoFirmaGte,
                responseValidateOrdenStateConfirmed.tipmon_id,
                parametros,
                responseValidateOrdenStateConfirmed.estope_id,
                initData.mi_subrogancia,
              ),
            );*/

            const IS_NOT_NEEDED_CEO_SIGN =
              VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
                totalValidado,
                montoFirmaGte,
                responseValidateOrdenStateConfirmed.tipmon_id,
                parametros,
                responseValidateOrdenStateConfirmed.estope_id,
                initData.mi_subrogancia,
              );

            //Sentry.captureMessage(`OC ${dataOrden.oc_id} CAMBIO ESTADO - IS_NOT_NEEDED_CEO_SIGN: ${IS_NOT_NEEDED_CEO_SIGN}`, "info");

            if (
              (responseValidateOrdenStateConfirmed.oc_id_estado_orden == 8 &&
                VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
                  totalValidado,
                  montoFirmaGte,
                  responseValidateOrdenStateConfirmed.tipmon_id,
                  parametros,
                  responseValidateOrdenStateConfirmed.estope_id,
                  initData.mi_subrogancia,
                )) ||
              responseValidateOrdenStateConfirmed.oc_id_estado_orden == 10
            ) {
              //##################################################################################//
              //#####################################220426########################################//
              //##################################################################################//
              // SI LA ORDEN CAMBIO A CONFIRMADA, LA SUBROGANCIA DE GERENCIA 81 ESTA ACTIVADA Y
              //LAS REGLAS DE NEGOCIO DE FIRMA DE GERENTE APLICARON , INYECTAMOS DOBLE ESTADO , 10

              /* Sentry.captureMessage(
                `OC ${dataOrden.oc_id} ESTADO CONFIRMADO - IS_NOT_NEEDED_CEO_SIGN: ${IS_NOT_NEEDED_CEO_SIGN}`,
                "info",
              );*/

              if (
                (responseValidateOrdenStateConfirmed.oc_id_estado_orden == 8 ||
                  responseValidateOrdenStateConfirmed.oc_id_estado_orden ==
                    10) &&
                initData.mi_subrogancia?.toString().split(",").includes("81") &&
                !AUX_VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
                  totalValidado,
                  montoFirmaGte,
                  responseValidateOrdenStateConfirmed.tipmon_id,
                  parametros,
                  responseValidateOrdenStateConfirmed.estope_id,
                )
              ) {
                //EMULAMOS UN NUEVA FIRMA DE SUBROGANCIA A GERENTE
                /* Sentry.captureMessage(
                  `OC ${dataOrden.oc_id} EMULANDO FIRMA DE SUBROGANCIA A GERENTE`,
                  "info",
                );*/

                try {
                  const objApprovalStateGteAuto = {
                    id_orden_compra: dataOrden.oc_id,
                    id_orden_compra_detalle: idDetalle,
                    id_orden_compra_estado: 10,
                    id_usuario_aprobador: initData.id,
                    observaciones: "subrogancia gerencia activada",
                    ip_registro: userIp,
                    dt_cre: new Date(),
                    dt_mod: new Date(),
                  };

                  const responseSaveNewStateOrdenAuxGteSubRog =
                    await api.POST_ORDENES_COMPRA_APPROVAL_STATE.sendOrdenCompraApprovalState(
                      Number(idDetalle),
                      JSON.stringify(objApprovalStateGteAuto),
                    );

                  if (responseSaveNewStateOrdenAuxGteSubRog !== null) {
                    /*  Sentry.captureMessage(
                      `OC ${dataOrden.oc_id} REGISTRADO EL NUEVO ESTADO DE OC AUTO DE GTE SUBROGANCIA`,
                      "info",
                    );*/

                    setLoadingMessage(
                      "Registrando historia de firma y enviando notificaciones automática de subrogancia...",
                    );
                    //REGISTRAMOS HISTORIAL DE APROBACION DE FIRMA CON NUEVO CODIGO VALIDADOR
                    //console.log("OBJETO APROBACION ESTADO: ", responseSaveNewStateOrden);
                    let objApprovalSignHisAux = {
                      id_usuario: initData.id,
                      id_orden_compra: dataOrden.oc_id,
                      id_orden_aprobacion_his:
                        responseSaveNewStateOrdenAuxGteSubRog.id,
                      id_algoritmo: self.crypto
                        .randomUUID()
                        .toString()
                        .substring(0, 15),
                      id_algoritmo_dos: "",
                      dt_cre: new Date(),
                    };

                    const responseSaveNewSignHisApprovalOrdenAuxGte =
                      await api.SEND_NEW_APPROVAL_SIGN_HIS_ORDER.sendNewApprovalSignHisOrder(
                        JSON.stringify(objApprovalSignHisAux),
                      );

                    if (responseSaveNewSignHisApprovalOrdenAuxGte !== null) {
                      /*console.log(
                        "SE REGISTRO EL NUEVO HISTORIAL DE FIRMA AUTOMÁTICA DE SUBROGANCIA DE GTE",
                      );*/

                      /*  Sentry.captureMessage(
                        `OC ${dataOrden.oc_id} REGISTRADA FIRMA SUBROGANTE CONF GG`,
                        "info",
                      );*/

                      //VALIDATE OC IS CONFIRMED CHECKING FOR 10 NOW
                      const responseValidateOrdenStateConfirmedGte =
                        await api.GET_ORDEN_COMPRA_BY_ID.getOrdenCompraById(
                          dataOrden.oc_id,
                        );

                      if (responseValidateOrdenStateConfirmedGte !== null) {
                        responseValidateOrdenStateConfirmed =
                          responseValidateOrdenStateConfirmedGte;
                        ordenConfirmedForInet.current =
                          responseValidateOrdenStateConfirmedGte;
                      }
                    }
                  }
                } catch (error) {
                  console.error(
                    "Error al registrar historia de firma automática de subrogancia o enviar notificaciones:",
                    error,
                  );
                }
              } //FIN BLOQUE DE DOBLE REGISTRO DE ESTADO

              //##################################################################################//
              //#####################################220426########################################//
              //##################################################################################//

              try {
                /*let dataProv = await fetchDatosProveedorById(dataOrden.prov_id);

                console.log(dataProv);

                console.log("dataProveedor.current: ", dataProveedor.current);
                if (
                  dataProveedor.current.prov_email !== null &&
                  dataProveedor.current.prov_email !== undefined &&
                  dataProveedor.current.prov_email !== ""
                ) {
                  console.log(
                    "PROVEEDOR TIENE EMAIL: ",
                    dataProveedor.current.prov_email,
                  );
                }*/

                if (appEnv === "production") {
                  setLoadingMessage("Subiendo archivo de orden al repositorio");

                  /*  Sentry.captureMessage(
                    `OC ${dataOrden.oc_id} ENTRAMOS EN SUBIDA DE ARCHIVO PDF DE OC A REPOSITORIO`,
                    "info",
                  );*/

                  // SE SUBE PERMANENTEMENTE LA ORDEN AL SERVIDOR UNA VEZ CONFIRMADA
                  let fileBlob = null;
                  const parts =
                    responseValidateOrdenStateConfirmed.oc_dt_cre.split("-");
                  const mes = parts[1];
                  const ano = parts[2];

                  let respuestaUploadFileOrder = null;
                  //let c = null;
                  /*await fetchDatosAprobacionesConfirmaciones(
                  dataOrden.oc_id
                ).then(async () => {
                  await fetchDatosFirmaAprobacionesConfirmaciones(
                    dataOrden.oc_id
                  ).then(async () => {
                    await fetchDatosProveedorById(dataOrden.prov_id).then(
                      async (responseData Prov) => {
                        console.log(
                          "Respuesta captura datos proveedor: ",
                          responseDataProv
                        );
                        if (responseDataProv !== null) {
                          fileBlob = await PdfCreatorForUploadFile({
                            data: dataOrden,
                            initData: initData,
                            ordenesApprovalStates:
                              ordenesCompraApprovalStates.current ?? [],
                            solicitudesSignApprovalHistory:
                              ordenesSignApprovalHistory.current ?? [],
                            dataProveedor: dataProveedor.current ?? {},
                            parametros: parametros,
                          });

                          respuestaUploadFileOrder =
                            await api.FILE_UPLOAD_ORDER.fileBlobUploadOrder(
                              fileBlob,
                              ano,
                              mes,
                              "ordenes",
                              dataOrden.oc_id
                            );

                          console.log(
                            "RESPUESTA UPLOAD ORDER: ",
                            respuestaUploadFileOrder
                          );
                          /*attachObj = {
                          name: `orden_compra_${dataOrden.oc_id}.pdf`,
                          data: fileBlob,
                          dirname: `/srv/ordenes/${ano}/${mes}/${dataOrden.oc_id}/pdf`,
                        };*/

                  respuestaUploadFileOrder = await handleGeneratePdfOcEmited(
                    responseValidateOrdenStateConfirmed,
                    ano,
                    mes,
                  );

                  if (respuestaUploadFileOrder !== null) {
                    //CONFIRMADA LA SUBIDA DE LA ORDEN DE COMPRA EN EL SERVIDOR COMO RESPALDO SE PROCEDE A
                    //DESCARGAR EL PDF DE LA ORDEN Y ENVIAR EL MAIL AL PROVEEDOR CON EL PDF ADJUNTO
                    //SI LA ORDEN ESTA EN ESTADO FINAL CONFIRMADA SE ENVIA MAIL AL PROVEEDOR | EL ATTACHMENT SE HACE EN EL API
                    let stringArrayOfCentrosCostoMail: string[] = [];
                    //let arrayAttach: any[] = [];
                    stringArrayOfCentrosCostoMail.push(
                      selectedRow?.sdetcc_nombre ?? "",
                    );

                    /* console.log(
                      "ESPERANDO SINCRONIZACION DE DISCOS PARA ADJUNTAR AL MAIL LA OC N°: ",
                      dataOrden.oc_id,
                    );*/
                    //PARA ESPERAR SINCRONIZACION DE DISCOS CON EL ARCHIVO
                    await new Promise((resolve) => setTimeout(resolve, 2000));

                    let paramEmiteOcNt = parametros.find(
                      (param: { codigo: string }) =>
                        param.codigo === "EMITOCNT",
                    )?.valor;

                    if (paramEmiteOcNt == 0) {
                      setLoadingMessage("Enviando notificación al proveedor.");

                      let mailsOrderArray: string[] = [
                        "sistemas.ti@salmonesdechile.com",
                        /*responseValidateOrdenStateConfirmed.oc_id_estado_orden ==
                        10
                          ? "roberto.pradenas@salmonesdechile.com"
                          : "",*/
                        responseEmailsDestinatarios.includes(
                          "magdalena.delgado@salmonesdechile.com",
                        )
                          ? "OCOPERACIONES@salmonesdechile.com"
                          : "",
                      ]; // responseEmailsDestinatarios.join(",")];
                      //rrayAttach.push(attachObj);

                      await fetchDatosProveedorById(dataOrden.prov_id);

                      if (
                        dataProveedor.current.email !== null &&
                        dataProveedor.current.email !== undefined &&
                        dataProveedor.current.email !== ""
                      ) {
                        responseEmailsDestinatarios.push(
                          dataProveedor.current.email,
                        );
                      }
                      if (
                        dataProveedor.current.contactoEmail !== null &&
                        dataProveedor.current.contactoEmail !== undefined &&
                        dataProveedor.current.contactoEmail !== ""
                      ) {
                        responseEmailsDestinatarios.push(
                          dataProveedor.current.contactoEmail,
                        );
                      }

                      let objMailNotifyOrdenProveedor = {
                        from: "noreply@salmonesdechile.com",
                        subjectEmail: `Se ha emitido la orden de compra N° ${dataOrden.oc_id}`,
                        sendTo: responseEmailsDestinatarios.join(","),
                        cc: mailsOrderArray.join(","),
                        template: "nuevoOrdenCompraProveedor",
                        nroOrden: dataOrden.oc_id,
                        usuario:
                          initData.nombres !== undefined
                            ? initData.nombres + " " + initData.apellido_paterno
                            : "solicitante sin nombres",
                        centroCosto: selectedRow?.sdetcc_nombre,
                        estado: selectedEstado,
                        nroDetalle: idDetalle,
                        path: `ordenes/${ano}/${mes}/${dataOrden.oc_id}/pdf/`,
                        attach: [
                          {
                            filename: `orden_${dataOrden.oc_id}.pdf`,
                            contentDisposition: "attachment",
                            path: `/opt/apps/fishweb-api-v1/tmp/ordenes/${ano}/${mes}/${dataOrden.oc_id}/pdf/orden_${dataOrden.oc_id}.pdf`,
                          },
                        ],
                      };

                      try {
                        await api.POST_SEND_EMAIL_NOTIFICATION_ATTACH_REPO.sendNewEmailWithAttachmentRepo(
                          JSON.stringify(objMailNotifyOrdenProveedor),
                        );

                        /* Sentry.captureMessage(
                          `OC ${dataOrden.oc_id} SE ENVIO EL MAIL DE LA OC AL PROVEEDOR`,
                          "info",
                        );*/
                      } catch (error) {
                        console.error(
                          "ERROR AL ENVIAR MAIL DE ORDEN DE COMPRA AL PROVEEDOR: ",
                          error,
                        );
                      }
                    }
                  }
                }

                //SI LA ORDEN ESTA EN ESTADO FINAL CONFIRMADA SE ACTUALIZA PRECIO DEL ITEM
                let responseUpdatePriceAndStock = null;
                //SE DEBEN RECORRER LOS DETALLES DE LA ORDEN CONFIRMADA PARA ACTUALIZAR TODOS LOS
                //PRECIOS POR CADA DETALLE CONFIRMADO DENTRO DE LA ORDEN
                for (const detalle of responseValidateOrdenStateConfirmed.detalle) {
                  try {
                    if (
                      ((detalle.ocest_id === 8 || detalle.ocest_id === 10) &&
                        VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
                          detalle.ocdet_precio_total,
                          montoFirmaGte,
                          responseValidateOrdenStateConfirmed.tipmon_id,
                          parametros,
                          responseValidateOrdenStateConfirmed.estope_id,
                          initData.mi_subrogancia,
                        )) ||
                      (detalle.ocest_id === 10 &&
                        !VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
                          detalle.ocdet_precio_total,
                          montoFirmaGte,
                          responseValidateOrdenStateConfirmed.tipmon_id,
                          parametros,
                          responseValidateOrdenStateConfirmed.estope_id,
                          initData.mi_subrogancia,
                        ))
                    ) {
                      setLoadingMessage("Registrando precio y stock del item.");
                      let objDataPriceStock = {
                        id_orden_compra: dataOrden.oc_id,
                        id_item_adquisicion: detalle.item_id,
                        cantidad_existencia: detalle.ocdet_cantidad,
                        ultimo_precio_unitario_neto:
                          detalle.ocdet_precio_unitario,
                        activo: 0,
                        dt_cre: new Date(),
                      };

                      responseUpdatePriceAndStock =
                        await api.POST_LAST_PRICE_STOCK_ITEM.postLastPriceStockItem(
                          JSON.stringify(objDataPriceStock),
                        );

                      /* Sentry.captureMessage(
                        `OC ${dataOrden.oc_id} REGISTRADO PRECIO DEL ITEM REF.`,
                        "info",
                      );*/

                      if (responseUpdatePriceAndStock === null) {
                        showMsg(
                          toast,
                          "warning",
                          "Advertencia",
                          `Ocurrió un error registrando el último precio del item ${detalle.item_nombre} y actualizando su stock, sin embargo, la actualización de la orden se registro correctamente.`,
                        );
                      }
                    }
                  } catch (error) {
                    console.error(
                      "Error updating price and stock for item ",
                      detalle.item_id,
                      ": ",
                      error,
                    );
                  }
                }

                if (appEnv === "production") {
                  let paramPrecioStockOcNt = parametros.find(
                    (param: { codigo: string }) => param.codigo === "PRISTONT",
                  )?.valor;

                  if (paramPrecioStockOcNt == 0) {
                    if (responseUpdatePriceAndStock !== null) {
                      try {
                        let objMailNotifyNewPriceItemAndStock = {
                          from: "noreply@salmonesdechile.com",
                          subjectEmail: `Se han actualizado los precios de los items en la orden de compra N° ${dataOrden.oc_id}`,
                          sendTo: "luis.liberal@salmonesdechile.com",
                          template: "nuevoPrecioStockOrden",
                          nroOrden: dataOrden.oc_id,
                          usuario:
                            initData.nombre !== undefined
                              ? initData.nombre
                              : "solicitante sin nombres",
                          centroCosto: selectedRow?.sdetcc_nombre,
                          estado: selectedEstado,
                          nroDetalle: idDetalle,
                          dataOrden: responseValidateOrdenStateConfirmed,
                        };

                        await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                          JSON.stringify(objMailNotifyNewPriceItemAndStock),
                        );
                      } catch (error) {
                        console.error(
                          "Error al enviar correo de notificación de actualización de precios: ",
                          error,
                        );
                        /*showMsg(
                          toast,
                          "warning",
                          "Advertencia",
                          `Ocurrió un error notificando el último precio de los items de la orden .`
                        );*/
                      }
                    }
                  }
                }
              } catch (error) {
                console.error(
                  "Ocurrió un error registrando la historia de aprobación y/o enviando el mail",
                  error,
                );
              }
            } else {
              if (
                responseValidateOrdenStateConfirmed.oc_id_estado_orden == 8 &&
                !VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
                  totalValidado,
                  montoFirmaGte,
                  responseValidateOrdenStateConfirmed.tipmon_id,
                  parametros,
                  responseValidateOrdenStateConfirmed.estope_id,
                  initData.mi_subrogancia,
                )
              ) {
                setLoadingMessage(
                  "Actualizando estado de la orden a pendiente por gerente.",
                );

                let objBody = {
                  id_orden_compra: dataOrden.oc_id,
                  id_estado_orden: 9,
                  dt_mod: new Date(),
                };

                const setPendienteGte =
                  await api.PUT_ORDENES_STATE_GTE.putUpdateOrdenCompraStateGte(
                    Number(selectedRow?.ocdet_id ?? 0),
                    JSON.stringify(objBody),
                  );

                if (setPendienteGte) {
                  //SE DEJA LA ORDEN CON ESTADO PENDIENTE POR GERENTE
                  /* showMsg(
                    toast,
                    "info",
                    "Información",
                    "La orden se ha dejado en estado pendiente por el gerente.",
                  );*/
                  /* Sentry.captureMessage(
                    `OC ${dataOrden.oc_id} QUDO EN ESTADO PENDIENTE GG`,
                    "info",
                  );*/
                } else {
                  /* showMsg(
                    toast,
                    "error",
                    "Información",
                    "La orden ha debido quedar en estado pendiente gerente; sin embargo, no se ha podido actualizar correctamente.",
                  );*/
                  /*  Sentry.captureMessage(
                    `OC ${dataOrden.oc_id} NO SE PUDO ACTUALIZAR EL ESTADO A PENDIENTE GG`,
                    "info",
                  );*/
                }
              } else {
                setShowModalLoadSpinner(false);
                setDialogEditaEstadoOc(false);
                setNeedFetchingDoc(true);
                return {
                  success: false,
                  estado:
                    responseValidateOrdenStateConfirmed?.oc_id_estado_orden,
                };
              }
            }

            setShowModalLoadSpinner(false);
            setDialogEditaEstadoOc(false);
            setNeedFetchingDoc(true);
            //setGoHome(true);

            let goInet = false;

            if (
              (responseValidateOrdenStateConfirmed.oc_id_estado_orden == 8 &&
                VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
                  totalValidado,
                  montoFirmaGte,
                  responseValidateOrdenStateConfirmed.tipmon_id,
                  parametros,
                  responseValidateOrdenStateConfirmed.estope_id,
                  initData.mi_subrogancia,
                )) ||
              responseValidateOrdenStateConfirmed.oc_id_estado_orden == 10
            ) {
              goInet = true;
              //REGISTRANDO ORDEN EMITIDA EN WEB (ANTES DE INET POR PROBLEMA PREVIO DE DESINCRONIZACION DE CONEXIONES WEB CON INET)
              let objOrdenEmitida = {
                id_orden_compra: dataOrden.oc_id,
                id_estado_orden:
                  responseValidateOrdenStateConfirmed?.oc_id_estado_orden,
                id_orden_subrogancia_gg: initData?.mi_subrogancia?.includes(
                  "81",
                )
                  ? (dataOrden?.oc_id ?? 0)
                  : 0,
              };
              const responseOrdenEmitida =
                await api.POST_ORDEN_EMITIDA.postOrdenCompraEmitida(
                  JSON.stringify(objOrdenEmitida),
                );

              if (responseOrdenEmitida !== null) {
                console.log("Emitió la orden en db");
                //console.log("Orden registrada como emitida en web");
                /* Sentry.captureMessage(
                  `OC ${dataOrden.oc_id} REGISTRADA COMO EMITIDA EN WEB`,
                  "info",
                );*/
              }
            }

            return {
              success: true,
              estado: responseValidateOrdenStateConfirmed?.oc_id_estado_orden,
              isNotNeededCeoSign: IS_NOT_NEEDED_CEO_SIGN,
              goInet: goInet,
            };
          }
        } catch (error) {
          console.error(
            "Ocurrió un error registrando la historia de aprobación y/o enviando el mail",
            error,
          );

          setShowModalLoadSpinner(false);
          showMsg(
            toast,
            "danger",
            "Error",
            "Ocurrió un error registrando el estado",
          );
        }
      }
    }
  };

  const sendOrdenCompraToInet = async (
    data: any,
    id: number,
    responsePrev: any,
  ) => {
    setLoadingMessage("Enviando orden de compra a INET");

    //console.log("ORDEN COMPRA ENVIANDOSE A INET DATA: ", data);
    const parts = data.occ_impuesto_especifico
      ? FORMAT_DATETIME_DDMMYYYY_GUION(data.fecha_orden_combustible).split("-")
      : data.oc_dt_cre.split("-");
    const mesOrden = parts[1];
    const anoOrden = parts[2];
    let sumTotalPreciosUnitarios = 0.0;
    let orderDate = data.occ_impuesto_especifico
      ? FORMAT_DATETIME_DDMMYYYY_GUION(data.fecha_orden_combustible)
      : data.oc_dt_cre;
    orderDate = CONVERT_DATE_TO_INET_FORMAT(orderDate);

    const proveedorData = await fetchDatosProveedorById(data.prov_id);
    const ordenesCompraApprovalStatesData =
      await fetchDatosAprobacionesConfirmaciones(data.oc_id);

    /*console.log("DATOS PROVEEDOR PARA INET: ", proveedorData);
    console.log(
      "DATA CONFIRMADA ORDEN ANTES DE INET: ",
      ordenConfirmedForInet.current,
    );>*/

    /*Sentry.captureMessage(
      `OC ${data.oc_id} ENVIANDOSE A INET: ${JSON.stringify(ordenConfirmedForInet.current)} . PROV: ${JSON.stringify(proveedorData)}`,
      "info",
    );*/

    let montoFirmaGte = parametros.find(
      (param: { codigo: string }) => param.codigo === "OC_FIR_GTE",
    )?.valor;

    let sucursalInetId = 1;

    if (initData.id_centro_costo == CENTRO_COSTO_ALIMENTOS_ADQUISICION) {
      //PARCHE MILPAN 14-01 POR MIENTRAS // NO SE PUEDEN MEZCLAR DETALLES DE ORDENES CON MILPAN ,
      // PORQUE CAERAN CON SUCURSAL 2
      /*  Sentry.captureMessage(`OC ${data.oc_id} ES SUC 2 ALIMENTOS`, "info"); */

      sucursalInetId = 2;
    }

    for (const detalle in ordenConfirmedForInet.current.detalle) {
      if (
        (ordenConfirmedForInet.current.detalle[detalle].ocest_id === 8 ||
          ordenConfirmedForInet.current.detalle[detalle].ocest_id === 10) &&
        VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
          ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total,
          montoFirmaGte,
          data.tipmon_id,
          parametros,
          data.estope_id,
          initData.mi_subrogancia,
        )
      ) {
        sumTotalPreciosUnitarios +=
          ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total;
      } else if (
        ordenConfirmedForInet.current.detalle[detalle].ocest_id === 10 &&
        !VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
          ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total,
          montoFirmaGte,
          data.tipmon_id,
          parametros,
          data.estope_id,
          initData.mi_subrogancia,
        )
      ) {
        sumTotalPreciosUnitarios +=
          ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total;
      }
    }

    const nombreSanitizado = proveedorData.nombre
      .replace(/[\n\r]/g, " ") // Reemplaza saltos de línea (Enter) por un espacio
      .replace(/\s+/g, " ") // Colapsa múltiples espacios en uno solo
      .trim() // Quita espacios al inicio y al final
      .substring(0, 40) // Corta a 35 caracteres (límite de INET)
      .toUpperCase(); // Opcional: convertir a mayúsculas para consistencia

    //EL CODIGO SUCURSAL SE TERMINARA DE DEFINIR JUNTO CON LOS DATOS DE SESION Y EL AZURE

    //AdqOdCtNu = Numero cotizacion no hay forma de capturarla hoy , 0 por defecto
    const fechaHoy = new Date()
      .toISOString()
      .replace("T", " ")
      .replace("Z", "");

    const tipoDocTributario = data.oc_id_tipo_doc_tributario - 1;

    const netoTotal = Number(sumTotalPreciosUnitarios) || 0;

    // 1. Safe parsing of Impuesto Especifico
    let impuestoEspecifico = 0.0;
    if (data.occ_impuesto_especifico != null) {
      const parsedImpEsp = Number(data.occ_impuesto_especifico);
      impuestoEspecifico =
        !isNaN(parsedImpEsp) && parsedImpEsp >= 1 ? parsedImpEsp : parsedImpEsp;
    }

    // 2. Initialize Impuesto to 0 by default (prevents undefined -> NaN -> null)
    let montoImpuestoValorOBoleta = 0.0;

    if (tipoDocTributario === 0) {
      // IVA (Factura Afecta)
      const paramIvaRaw = parametros.find(
        (param: { codigo: string }) => param.codigo === "IVA",
      )?.valor;
      const paramIva = Number(paramIvaRaw) || 1.19; // Default fallback to 1.19 if missing

      montoImpuestoValorOBoleta = netoTotal * paramIva - netoTotal;
    } else if (tipoDocTributario === 2) {
      // BOLETA
      const paramBoletaRaw = parametros.find(
        (param: { codigo: string }) => param.codigo === "BOLETA",
      )?.valor;
      const paramBoletaImp = Number(paramBoletaRaw) || 1.1375; // Fallback if missing

      montoImpuestoValorOBoleta = netoTotal * paramBoletaImp - netoTotal;
    }

    // 3. Calculate Total Afecto safely
    const montoTotalAfecto =
      netoTotal +
      montoImpuestoValorOBoleta +
      (data.occ_impuesto_especifico != null ? impuestoEspecifico : 0);

    const fullName = [
      ordenesCompraApprovalStatesData[1]?.nombres,
      ordenesCompraApprovalStatesData[1]?.apellidos,
    ]
      .filter(Boolean)
      .join(" ")
      .toUpperCase();

    let objDataOrdenCompra = {
      SucCod: sucursalInetId,
      AdqOdAno: Number(anoOrden),
      AdqOdMes: Number(mesOrden),
      AdqOdNum: Number(data.oc_id), //FUTURO data.oc_id (PARTIENDO DESDE ULTIMO CORRELATIVO INET)// CORRELATIVO DE ORDEN DE COMPRA // NO SE DEBERIA ENVIAR ESTE VALOR QUE GENERA UNA SECUENCIA -- LA TABLA PARTIRA EL ID DESDE
      AdqOdTip: AUX_TIPO_DOCUMENTO_INET_CONVERT(data.subdoc_id), //TIPO DE ORDEN, STOCK 2, SERVICIO 1, INVERSIONES 3, ACTIVOS 4.
      AdqOdFcIn: orderDate,
      AdqOdCtNu: 0, //COTIZACION VA EN 0
      AdqOdCtFe: orderDate, // FECHA COTIZACION DEJAR LA DE INGRESO
      AdqOdNCPr: 0, //HORA SERVIDOR
      PrvTip: 1, //TIPO CODIGO EMPLEADOR = 0 O RUT = 1
      PrvCod: proveedorData.identificador, //RUT PROVEEDOR
      PrvSec: 0, //SECUENCIA PROVEEDOR , DEJAR EN 0
      AdqOdPvNo: nombreSanitizado ?? " ", //NOMBRE PROVEEDOR
      PerTip: 1, //1 para rut
      PerCod: ordenesCompraApprovalStatesData[1]?.identificador ?? 0, //ordenesCompraApprovalStatesData[3]?.identificador ?? //ordenesCompraApprovalStatesData[2]?.identificador ?? //"0", //RUT DEL PAPI DE LOS PAPIS DE ESTA ORDEN
      PerSec: 0,
      AdqOdPeNo: fullName, //ordenesCompraApprovalStatesData[1]?.nombres ?? //ordenesCompraApprovalStatesData[3]?.nombres ?? //ordenesCompraApprovalStatesData[2]?.nombres ?? //"0", //NOMBRE DEL PAPI DE LOS PAPIS DE ESTA ORDEN
      AdqOdGlo: "",
      AdqOdDis: 0,
      AdqOdCvCo:
        data.oc_condicion_pago != null ? data.oc_condicion_pago - 1 : 2, //CODIGO DE CONDICION PAGO EN PARAMETRO TABLA OC - SI NO SE TOMO 30 POR DEFECTO
      AdqOdMoCo: data?.tipmon_id
        ? data.tipmon_id == 40
          ? 41
          : data.tipmon_id == 41
            ? 42
            : data.tipmon_id
        : 1, //CODIGO TIPO DE MONEDA
      AdqOdPlaC:
        data.subdoc_id == 2 || data.subdoc_id == 6 ? 21060301 : 21060303, //CODIGO CONTABLE DE CUENTA CONTABLE POR DEFECTO PARA STOCK , PARA LAS RELACIONADAS 03 //21060301 Facturas por recibir , 21060303 Facturas por recibir servicios, 60010101 Orden al haber
      AdqOdCenC: 0, //22-12 para todos los casos
      AdqOdAnaT: 1, //1 rut 0 codigo empleado
      AdqOdAnaC: proveedorData.identificador, // RUT PROVEEDOR
      AdqOdAnaS: 0, //SECUENCIA NO SE USARA MAS
      AdqOdAreC: 0, //22-12 actualizacion dejar en 0 , AREA CENTRO COSTO DE LA ORDEN
      AdqOdIteC: 0,
      AdqOdEst: 2, // ORDEN ESTADO 0- pendiente, 1- Aprobada, 2- Emitida, 3-SemiCumplida, 4- Cumplida, 5- Nula, 6- Rechazadas
      AdqOdDsc1: 0.0,
      AdqOdDsc2: 0.0,
      AdqOdUltL: 0, //ESTO SOLO AFECTA A GENERACIONES DE ORDENES DE NUEVA EN INET - SE DEJA EN 0
      AdqOdTaAp: data.tipmon_id == 1 ? 1 : data.tipmon_id == 39 ? 1 : 2, // Tipo de cambio 2 - referencial ,  1 firme  ... Se deja referencial por defecto
      AdqOdTaCa: data.tasa_cambio ?? 1, // Tipo de cambio del dia de la generacion de la orden para la moneda de la orden
      AdqOdAuUs: data.user_usu_login, //Usuario que crea la orden , esta esperando el login de inet en string
      AdqOdAuFc: orderDate, //Fecha de creación de orden de compra
      AdqOdAuHr: "00:00:00", //Hora la toma del servidor
      AdqOdDir: 0, // DIRECTA 1 Y NO DIRECTA 0
      AdqOdToNe: sumTotalPreciosUnitarios, //TOTAL PRECIO UNITARIO
      AdqOdCtSu: 0, //COTIZACIONES
      AdqOdCtAn: 0, //COTIZACIONES
      AdqOdCtMe: 0, //COTIZACIONES
      AdqOdPrNu: 0, //NUMERO DE CENTRALIZACION SE ACTUALIZA CUANDO SE HACE EL CIERRE CONTABLE - COMPROBANTE EMITIDO POR INET
      AdqOdPrFc: CONVERT_DATE_TO_INET_FORMAT("01-01-1753"),
      AdqOdPrAm: 0, //Number(anoOrden) + Number(mesOrden), //AÑO Y MES // YYYYMM //
      AdqOdNuRe: data.oc_id, //ESTE ES EL NUMERO DE LA ORDEN DE LA WEB QUE DEBE IR AL MOMENTO DE LA IMPLEMENTACION CON EL ULTIMO EXISTENTE MAYOR ENTRE TODAS LAS SUCURSALES EN INET +1
      AdqOdLbCm: tipoDocTributario, //FACTURA AFECTA 0, EXENTA 1, BOLETA 2 // LIBRO COMPRA
      AdqOdFor: 0, //ORDEN DE COMPRA FORZADA = 1 O NO = 0
      AdqOdUsAp:
        [ordenesCompraApprovalStatesData[3], ordenesCompraApprovalStatesData[2]]
          .map((item) =>
            item?.nombres
              ? `${item.nombres} ${item.apellidos ?? ""}`.trim()
              : null,
          )
          .find(Boolean) ?? "SISTEMA", // USUARIO CONFIRMADOR | APROBADOR
      AdqOdRech: "", //JUSTIFICACION DE RECHAZO
      AdqOdOrdN: 0,
      AdqOdSubO: 0,
      AdqOdOtNu: 0,
      AdqOdPerF: 0,
      AdqOdPerU: 0,
      AdqOding: 0,
      ADQODAPFC: (
        ordenesCompraApprovalStatesData[3] || ordenesCompraApprovalStatesData[2]
      )?.fechaCreacion
        ? String(
            (
              ordenesCompraApprovalStatesData[3] ||
              ordenesCompraApprovalStatesData[2]
            ).fechaCreacion,
          )
            .replace("T", " ")
            .replace("Z", "")
        : "2025-01-01 00:00:00.000", //FECHA DE CONFIRMACION DE LA ORDEN
      ADQODAPHR: "00:00:00", //HORA SERVIDOR DE LA CONFIRMAR ORDEN
      ADQODEMFC: fechaHoy, //FECHA DE EMISION DE LA ORDEN CONECTAR CON MOMENTO  DE ENVIO DE ORDEN AL PROVEEDOR
      ADQODEMHR: "00:00:00", //HORA  SERVIDOR DE EMISION
      ADQODEMUS: data.user_usu_login, // USUARIO SOLICITANTE , YA NO HAY USUARIO QUE EMITE //LOGIN INET
      AdqOdCCApC: 0,
      AdqOdUsIn: data.user_usu_login, // USUARIO SOLICITANTE , YA NO HAY USUARIO QUE EMITE //LOGIN INET
      AdqOdFin: 0,
      AdqOdTNL: Number(sumTotalPreciosUnitarios), // IDENTIFICADO 17-08 como equivalente al total neto
      AdqOdTDe: 0,
      AdqOdTAf: Number(sumTotalPreciosUnitarios), // IDENTIFICADO 17-08 como equivalente al total neto
      AdqOdTEx: 0,
      AdqOdTIm: Number(impuestoEspecifico) || 0, // IDENTIFICADO 17-08-26 COMO IMPUESTO ESPECIFICO
      AdqOdTIv: Math.round(Number(montoImpuestoValorOBoleta)) || 0, //IDENTIFICADO 17-08-26 COMO MONTO IVA O IMPUESTO BOLETA
      AdqOdTot: Math.round(Number(montoTotalAfecto)) || 0, // IDENTIFICADO 17-08-26 COMO TOTAL AFECTO CON IMPUESTOS
      AdqOdApiE: 1,
      AdqClCod: 0,
    };

    let arrayDetallesOc = [];
    let arrayDetallesOcGlosa = [];
    let contadorAux = 0;

    try {
      for (const detalle in ordenConfirmedForInet.current.detalle) {
        if (
          ((ordenConfirmedForInet.current.detalle[detalle].ocest_id === 8 ||
            ordenConfirmedForInet.current.detalle[detalle].ocest_id === 10) &&
            VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
              ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total,
              montoFirmaGte,
              data.tipmon_id,
              parametros,
              data.estope_id,
              initData.mi_subrogancia,
            )) ||
          (ordenConfirmedForInet.current.detalle[detalle].ocest_id === 10 &&
            !VALIDATE_NO_SIGNATURE_CEO_ORDER_PURCHASE(
              ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total,
              montoFirmaGte,
              data.tipmon_id,
              parametros,
              data.estope_id,
              initData.mi_subrogancia,
            ))
        ) {
          //SOLO ENVIAMOS DETALLES CONFIRMADOS AL INET

          contadorAux++;
          let contadorAuxGlosa = 1;
          //RECUPERACION DE OLD_ID DE DE CENTRO PARA INET
          let centroCostoDetalle = centrosCostoFull.find(
            (centro) =>
              centro.id ===
              ordenConfirmedForInet.current.detalle[detalle].sdetcc_id,
          );

          let areaDetalle = centrosCostoFull.find(
            (centro) =>
              centro.id ===
              ordenConfirmedForInet.current.detalle[detalle].sdetcc_id,
          );
          //RECUPERACION DE CODIGO ITEM PARA INET
          let itemAdqCodigoDetalle = itemsAdquisicionFull.find(
            (item) =>
              item.id ===
              ordenConfirmedForInet.current.detalle[detalle].item_id,
          );

          itemAdqCodigoDetalle =
            itemAdqCodigoDetalle.nombre_compuesto.split(" -");
          //CUANDO ES STOCK LA ORDEN:  ANAT , ANAC , ANAS , AREC, ITEC ES 0 Y LA CUENTA CONTABLE ES MATERIALES BODEGA CENTRAL PARA TODOS LOS ITEMS
          let objDataOrdenCompraDetalle = {
            SucCod: sucursalInetId,
            AdqOdAno: Number(anoOrden),
            AdqOdMes: Number(mesOrden),
            AdqOdNum: Number(data.oc_id), //FUTURO data.oc_id, CORRELATIVO DE ORDEN DE COMPRA // NO SE DEBERIA ENVIAR ESTE VALOR QUE GENERA UNA SECUENCIA -- SUCEMP TIENE ESTOS CORRELATIVOS
            AdqOlLin: contadorAux, //NUMERO DE LINEA
            PrdCod: itemAdqCodigoDetalle[0], //CODIGO DEL ITEM
            AdqOlFcEn: orderDate, //FECHA DE ENTREGA DEL PRODUCTO , DEJAR POR DEFECTO FECHA DE REGISTRO OC
            AdqOlQCom:
              ordenConfirmedForInet.current.detalle[detalle].ocdet_cantidad, //CANTIDAD DE PRODUCTO
            AdqOlPrNa:
              ordenConfirmedForInet.current.detalle[detalle]
                .ocdet_precio_unitario, //PRECIO UNITARIO NETO
            AdqOlVal:
              ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total, //PRECIO UNITARIO TOTAL NETO
            AdqOlPrMo:
              ordenConfirmedForInet.current.detalle[detalle]
                .ocdet_precio_unitario, //PRECIO UNITARIO NETO
            AdqOlDsc1: 0, //DESCUENTOS , DEJAR EN 0 NO APLICA
            AdqOlVDs1: 0, //DESCUENTOS, DEJAR EN 0
            AdqOlVal1:
              ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total,
            AdqOlDsc2: 0,
            AdqOlVDs2: 0,
            AdqOlVal2:
              ordenConfirmedForInet.current.detalle[detalle].ocdet_precio_total, //VALOR EN BASE A DESCUENTOS DEJAR // DEJAR igual que AdqOlVal
            AdqOlValN:
              tipoDocTributario == 1 || tipoDocTributario == 3
                ? 0
                : ordenConfirmedForInet.current.detalle[detalle]
                    .ocdet_precio_total, // DEJAR igual que AdqOlVal // 03-02 SI ES FACTURA EXENTA O BOLETA EXENTA VA 0
            AdqOlImp1: 0, //IMPUESTO ASOCIADO AL ITEM // DEJAR EN 0 EN ESTA ETAPA
            AdqOlImp2: 0, //IMPUESTO ASOCIADO AL ITEM // DEJAR EN 0 EN ESTA ETAPA
            AdqOlPlaC:
              data.subdoc_id == 2 || data.subdoc_id == 6
                ? "21060301"
                : "21060303", //CODIGO CONTABLE DE CUENTA CONTABLE CON REGLA PARTICULAR STOCK = MATERIALES BODEGA CENTRAL, CUANDO ES SERVCIO LLEVA SU CUENTA ASOCIADA, ACTIVO FIJO CUENTA ASOCIADA, INVERSIONES CUENTA ASOCIADA.
            AdqOlCenC:
              data.subdoc_id == 2 || data.subdoc_id == 6
                ? 0
                : centroCostoDetalle.old_id, //SE ESPERA EL ID DEL CENTRO INET
            AdqOlAnaT: 1, //1 rut 0 codigo empleado
            AdqOlAnaC: proveedorData.identificador, // RUT PROVEEDOR
            AdqOlAnaS: 0, //SECUENCIA DEJAR EN 0
            AdqOlAreC:
              data.subdoc_id == 2 || data.subdoc_id == 6
                ? 0
                : centroCostoDetalle.id_area == 1
                  ? 2
                  : centroCostoDetalle.id_area == 3 ||
                      centroCostoDetalle.id_area == 8
                    ? 3
                    : 1, //AREA CENTRO COSTO DE LA ORDEN , CUANDO ES STOCK
            AdqOlIteC: data.subdoc_id == 2 || data.subdoc_id == 6 ? 0 : 0, //CODIGO ITEM A NIVEL CONTABLE , 0 CUANDO ES STOCK // DA ERROR CON CUENTA CONTABLE ES UN SMALL INT Y NO LO SOPORTA
            AdqOlQCot: 0.0, //COTIZACION , DEJAR EN 0
            AdqOlQRec: 0.0, //CANTIDAD RECEPCIONADA DEL PRODUCTO
            AdqOlQFor: 0.0, //CANTIDAD DE RECEPCION FORZADA
            AdqOlTlGl: 0, //CANTIDAD DE LINEAS GLOSA ; IRRELEVANTE
            AdqOlVIm2: 0.0, //
            AdqOlVIm1: Number(impuestoEspecifico), // IDENTIFICADO 17-08-26 COMO IMPUESTO ESPECIFICO
            AdqOlQDev: 0.0, //
            AdqOlTCDi: 0.0, //
            AdqOlIm1C: 0,
            AdqOlIm2C: 0,
            AdqOlQRev: 0.0, //Se actualiza posteriormente
            adqolexe: tipoDocTributario == 1 || tipoDocTributario == 3 ? 1 : 0, // SI ES EXENTO 1 SI ES AFECTO 0
            adqolvale:
              tipoDocTributario == 1 || tipoDocTributario == 3
                ? ordenConfirmedForInet.current.detalle[detalle]
                    .ocdet_precio_total
                : 0.0,
            adqolSnCr: 0,
            AdqOlVLIN1: 0.0,
            AdqOlVLIN2: 0.0,
            AdqOlVLIN3: 0.0,
            AdqOlCCApC: 0,
          };

          arrayDetallesOc.push(objDataOrdenCompraDetalle);

          let objDataOrdenCompraDetalleGlosa = {
            SucCod: sucursalInetId,
            AdqOdAno: Number(anoOrden),
            AdqOdMes: Number(mesOrden),
            AdqOdNum: Number(data.oc_id), //futuro oc_id, CORRELATIVO DE ORDEN DE COMPRA // NO SE DEBERIA ENVIAR ESTE VALOR QUE GENERA UNA SECUENCIA -- SUCEMP TIENE ESTOS CORRELATIVOS
            AdqOlLin: contadorAux, //NUMERO DE LINEA
            AdqOgLin: contadorAuxGlosa,
            AdqOgGlo: FORMAT_TEXT_FOR_INET(
              ordenConfirmedForInet.current.detalle[
                detalle
              ].ocdet_observaciones.slice(0, 80),
            ), //detalle del detalle de la orden
          };

          arrayDetallesOcGlosa.push(objDataOrdenCompraDetalleGlosa);
        }
      }
    } catch (error) {
      console.error("Error procesando detalles para INET: ", error);
    }

    /* Sentry.captureMessage(
      `OC ${data.oc_id} ADQORD: ${JSON.stringify(objDataOrdenCompra)}`,
      "info",
    );*/

    try {
      //if (appEnv === "production") {
      //ENVIAMOS EL OBJETO CABECERA DE LA COMPRA A INET
      const response = await api.SEND_ORDEN_COMPRA_INET.sendOrdenCompraInet(
        JSON.stringify(objDataOrdenCompra),
        data.oc_id,
      );

      if (response !== null) {
        //ENVIAMOS EL OBJETO DE ORDEN DE COMPRA DETALLE A INET
        const responseOrdenDetalle =
          await api.SEND_ORDEN_COMPRA_DETALLE_INET.sendOrdenCompraDetalleInet(
            JSON.stringify(arrayDetallesOc),
            data.oc_id,
          );

        /* Sentry.captureMessage(
          `OC ${data.oc_id} ADQORL: ${JSON.stringify(arrayDetallesOc)}`,
          "info",
        );*/

        if (responseOrdenDetalle !== null) {
          //ENVIAMOS EL OBJETO DE DETALLE GLOSA A INET
          const responseOrdenDetalleGlosa =
            await api.SEND_ORDEN_COMPRA_DETALLE_GLOSA_INET.sendOrdenCompraDetalleGlosaInet(
              JSON.stringify(arrayDetallesOcGlosa),
              data.oc_id,
            );

          /* Sentry.captureMessage(
            `OC ${data.oc_id} ADQORG: ${JSON.stringify(arrayDetallesOcGlosa)}`,
            "info",
          );*/

          if (responseOrdenDetalleGlosa) {
            /* Sentry.captureMessage(
              `OC ${data.oc_id} REGISTRADA OK EN INET, GLOSA: ${JSON.stringify(responseOrdenDetalleGlosa)}`,
              "info",
            );*/
          } else {
            /*Sentry.captureMessage(
              `OC ${data.oc_id} ERROR ENVIANDO GLOSA A INET`,
              "info",
            );*/
          }
        } else {
          /*showMsg(
            toast,
            "danger",
            "Error",
            "Ocurrió un error enviando los detalles de la orden de compra a INET",
          );*/
          /*Sentry.captureMessage(
            `OC ${data.oc_id} ERROR ENVIANDO DETALLE A INET`,
            "info",
          );*/
          /*console.log(
            "Ocurrió un error enviando los detalles de la orden de compra a INET: ",
            responseOrdenDetalle,
          );*/
        }

        //await Sentry.flush(2000);
        //console.log("respuesta envio cabecera orden al inet: ", response);
        return response;
      } else {
        /*showMsg(
          toast,
          "danger",
          "Error",
          "Ocurrió un error enviando los detalles de la orden de compra a INET",
        );*/
        /*Sentry.captureMessage(
          `OC ${data.oc_id} ERROR ENVIANDO CABECERA A INET`,
          "info",
        );*/
        /*console.log(
          "Ocurrió un error enviando la orden de compra a INET: ",
          response,
        );*/
      }
      //} //FIN PRODUCCION

      /*if (
        appEnv === "development" &&
        ((responsePrev.isNotNeededCeoSign == true &&
          responsePrev.estado == 8) ||
          (responsePrev.isNotNeededCeoSign == false &&
            responsePrev.estado == 10))
      ) {
        let objOrdenEmitida = {
          id_orden_compra: data.oc_id,
          id_estado_orden: responsePrev.estado,
          id_orden_subrogancia_gg: responsePrev.isNotNeededCeoSign,
        };
        const responseOrdenEmitida =
          await api.POST_ORDEN_EMITIDA.postOrdenCompraEmitida(
            JSON.stringify(objOrdenEmitida),
          );

        if (responseOrdenEmitida !== null) {
          //console.log("Orden registrada como emitida en web");
          Sentry.captureMessage(
            `OC ${data.oc_id} REGISTRADA COMO EMITIDA EN WEB`,
            "info",
          );
        }
      }*/
    } catch (error) {
      console.error("Error al enviar orden de compra a INET: ", error);
      throw error;
    }
  };

  /*******************************************************************************/
  // SECCION DE NUEVO DETALLE
  const addNewDetail = (data: any) => {
    if (data.socest_id > 6) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "No se pueden agregar detalles a una solicitud con confirmaciones",
      );
      return;
    }

    if (contextmenu == "aprueba" || contextmenu == "confirma") {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "No está permitido agregar detalles sobre una solicitud de terceros",
      );
      return;
    }

    if (
      initData.roles.some(
        (role: { codigo: string }) => role.codigo === "MANOC",
      ) &&
      data.user_id === initData.id &&
      contextmenu == "mantiene"
    ) {
      setNewDetalle(emptyNewDetaille);
      setSelectedNumeroOrdenCompra(data.oc_id);
      //EL EMPTY DETALLE PASA POR SETEAR LOS ESTADOS QUE TAMBIEN SON OCUPADOS EN LA EDICION
      setSelectedMesGasto("");
      setSelectedMesGastoId(0);
      setSelectedEStadoOp("");
      setSelectedEstadoOpId(0);
      setSelectedTipoMoneda("");
      setSelectedTipoMonedaId(0);
      setSelectedTipoDocTributarioId(0);
      setSelectedCondicionPago("");
      setSelectedCondicionPagoId(0);
      setSelectedTipoDocTributario("");
      setSelectedTipoOrden("");
      setSelectedTipoOrdenId(0);
      setSelectedEstado("");
      setSelectedEstadoId(0);
      setSelectedCantidad(0);
      setSelectedCentroCosto("");
      setSelectedCentroCostoId(0);
      setSelectedProveedor("");
      setSelectedProveedorId(0);
      setSelectedItem("");
      setSelectedItemId(0);
      setSelectedEstado("");
      setSelectedEstadoId(0);
      setselectedPrecioUnitarioRef(0);
      setSelectedPrecioTotalRef(0);
      selectedDetalles.current = "";

      setSubmittedNewDetail(false);
      setNewDetailDialog(true);
    }
  };

  const addMarcaVista = async (data: any) => {
    const responseMarcaVistaOrden =
      await api.POST_ORDEN_VISTA_MARCA.postOrdenVistaMarca(
        data.oc_id,
        initData.id,
      );
    if (responseMarcaVistaOrden !== null) {
      setNeedFetchingDoc(true);
    }
    {
      console.log("Error registrando marca de vista");
    }
  };

  const saveNewDetail = () => {
    setSubmittedNewDetail(true);

    let detallesDivText = document.getElementById("os_detalles_0")?.innerHTML;

    const precioUnitario = document.getElementById(`os_precio_unitario_0`)
      ?.childNodes[0] as HTMLFormElement;

    const precioUnitarioTotal = document.getElementById(
      `os_precio_unitario_total_0`,
    )?.childNodes[0] as HTMLFormElement;

    const jsonDetalleObj: any = {
      idsolicitudoc: selectedNumeroOrdenCompra,
      cantidad: selectedCantidad.toString(),
      item: selectedItemId,
      centrocosto: selectedCentroCostoId,
      proveedor: selectedProveedorId,
      preciorefunitario: precioUnitario.value,
      preciorefunitariototal: precioUnitarioTotal.value,
      detalles: (detallesDivText ?? selectedDetalles.current) || "",
    };
    //CAPTURA ESPECIAL DE ULTIMA FILA PARA VALIDAR ANTES DE REGISTRAR

    if (selectedCantidad == 0) {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar una cantidad");
    } else if (selectedItem == "") {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar un item");
    } else if (selectedCentroCosto == "") {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar un centro de costo");
    } else if (selectedProveedor == "") {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar un proveedor");
    } else if (selectedPrecioUnitarioRef == 0) {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar un precio unitario");
    } else if (selectedPrecioTotalRef == 0) {
      showMsg(toast, "warn", "Advertencia", "El total debe ser mayor a 0");
    } else if (
      (selectedEstadoId == 4 || selectedEstadoId == 2) &&
      !VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT(detallesDivText)
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Solo puedes ingresar en los detalles adicionales (glosas) letras, números, puntos, comas, guión o guión bajo, no se permiten espacios al final ni saltos de línea con enter.",
      );
    } else {
      setJsonDataOrdenCompra(jsonDetalleObj);
      setShowModalConfirmNewDetail(true);
    }
  };

  const hideDeleteDetailDialog = () => {
    setDeleteNewDetailDialog(false);
  };

  const hideDeleteDetailsDialog = () => {
    setDeleteNewDetailsDialog(false);
  };

  const deleteDetail = () => {
    /* let _products = products.filter((val) => val.id !== product.id);
  
          setProducts(_products);
          setDeleteProductDialog(false);
          setProduct(emptyProduct);
          toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });*/
  };

  const newDetailtDialogFooter = (
    <>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={hideNewDialog}
      />
      <Button label="Save" icon="pi pi-check" onClick={saveNewDetail} />
    </>
  );
  /*******************************************************************************/

  const textAreaRender = () => (
    <div
      contentEditable="true"
      suppressContentEditableWarning={true}
      style={{
        border: 1,
        borderStyle: "solid",
        width: "280px",
        height: "140px",
        padding: "20px",
      }}
      id="os_detalles_0"
      onError={() => alert("XSS detectado")}
      dangerouslySetInnerHTML={createMarkup()}
    ></div>
  );

  const sanitizedHtml = () => {
    // Ensure selectedDetalles.current is defined and handle both string or array-like values safely.
    const current = selectedDetalles.current ?? "";
    return DOMPurify.sanitize(current);
  };

  const createMarkup = () => {
    try {
      return { __html: sanitizedHtml() };
    } catch (error) {
      console.log("Error: ", error);
      return { __html: "" };
    }
  };

  const rowExpansionTemplate = (data: any) => {
    const parts = data.oc_dt_cre.split("-");
    const mes = parts[1];
    const ano = parts[2];

    const handleGeneratePdfOc = async (data: any) => {
      fetchDatosAprobacionesConfirmaciones(data.oc_id).then(() => {
        fetchDatosFirmaAprobacionesConfirmaciones(data.oc_id).then(() => {
          fetchDatosProveedorById(data.prov_id).then(() => {
            PdfCreator({
              data: data,
              initData: initData,
              ordenesApprovalStates: ordenesCompraApprovalStates.current ?? [],
              solicitudesSignApprovalHistory:
                ordenesSignApprovalHistory.current ?? [],
              dataProveedor: dataProveedor.current ?? {},
              parametros: parametros,
            });
          });
        });
      });
    };

    const confirmarAnulacion = (data: any) => {
      confirmDialog({
        message: `¿Estás seguro de que deseas anular la orden de compra N° ${data.oc_id}? Esta acción afectará a ambos sistemas de forma síncrona.`,
        header: "Confirmar Anulación",
        icon: "pi pi-exclamation-triangle",
        defaultFocus: "reject",
        acceptClassName: "p-button-danger",
        acceptLabel: "Sí, Anular",
        rejectLabel: "No, Cancelar",
        accept: () => nuleOrdenCompraWebInet(data), // Si acepta, se ejecuta tu función
        reject: () => {
          /* Opcional: acción si cancela */
        },
      });
    };

    const nuleOrdenCompraWebInet = async (data: any) => {
      let webUpdateSuccess = false;
      console.log("Iniciando anulación de orden de compra N°", data);
      let estadoPrevioOrden = data.oc_id_estado_orden;
      let sucursalInetId = 1;
      if (initData.id_centro_costo == CENTRO_COSTO_ALIMENTOS_ADQUISICION) {
        //PARCHE MILPAN 14-01 POR MIENTRAS // NO SE PUEDEN MEZCLAR DETALLES DE ORDENES CON MILPAN ,
        // PORQUE CAERAN CON SUCURSAL 2
        sucursalInetId = 2;
      }
      const parts = data.oc_dt_cre.split("-");
      const mesOrden = parts[1];
      const anoOrden = parts[2];

      const userIp = await getUserIp();

      let objDataWeb = {
        id_orden_compra: data.oc_id,
        id_estado_orden: 2,
        id_usuario_aprobador: initData.id,
        ip_registro: userIp,
        observaciones:
          data.oc_observaciones +
          " - Anulada orden de compra emitida desde adquisiciones",
        dt_mod: new Date().toISOString(),
      };

      let objDataInet = {
        SucCod: sucursalInetId,
        AdqOdAno: Number(anoOrden),
        AdqOdMes: Number(mesOrden),
        AdqOdNum: Number(data.oc_id),
        AdqOdEst: 5,
        AdqOdRech: "Anulada orden de compra emitida desde adquisiciones",
      };

      try {
        // 1. Intentamos actualizar la API Web
        const responseWeb =
          await api.PUT_ORDEN_COMPRA_NULA.putUpdateOrdenCompraNula(
            data.oc_id,
            JSON.stringify(objDataWeb),
          );
        // Si llegó aquí, la API Web ya guardó en su BD
        webUpdateSuccess = true;

        console.log("Anulación exitosa en web");
        // 2. Intentamos actualizar la API Inet
        const responseInet =
          await api.PUT_ORDEN_COMPRA_NULA_INET.putUpdateOrdenCompraNulaInet(
            data.oc_id,
            JSON.stringify(objDataInet),
          );

        showMsg(
          toast,
          "success",
          "Éxito",
          `La orden de compra N° ${data.oc_id} ha sido anulada correctamente en ambos sistemas.`,
        );

        setNeedFetchingDoc(true);

        return { responseWeb, responseInet };
      } catch (error: any) {
        console.error("Error en la operación distribuida:", error.data.error);

        // 3. COMPENSACIÓN: Si Web se ejecutó pero Inet falló, hacemos el "Rollback" manual en Web
        if (webUpdateSuccess) {
          try {
            console.warn(
              "API Inet falló. Revirtiendo cambios en API Web para mantener consistencia...",
            );

            console.log("Error details:", error);
            if (error.message == 400) {
              // Llamamos a un endpoint que deshaga la anulación en la API Web
              objDataWeb.id_estado_orden = estadoPrevioOrden; // Revertimos al estado anterior
              objDataWeb.observaciones =
                data.observaciones + "Revertido estado de anulación."; // Revertimos las observaciones al estado original
              await api.PUT_ORDEN_COMPRA_NULA.putUpdateOrdenCompraNula(
                data.oc_id,
                JSON.stringify(objDataWeb),
              );

              console.log(
                "Reversión exitosa. Ambas BDs quedaron en su estado original.",
              );

              showMsg(
                toast,
                "warning",
                "Warn",
                `La orden de compra N° ${data.oc_id} se anuló exitosamente en web. Inet: ${error.data.error}`,
              );
            } else {
              showMsg(
                toast,
                "danger",
                "Error",
                `La orden de compra N° ${data.oc_id} no se ha podido anular en Inet. Error: ${error.data.error}`,
              );
            }
          } catch (compensateError) {
            // Alerta máxima: Falló la API Inet Y TAMBIÉN falló la reversión de la API Web
            console.error(
              "¡ERROR CRÍTICO! Los datos quedaron inconsistentes.",
              compensateError,
            );

            showMsg(
              toast,
              "danger",
              "Error",
              `No se pudo completar la operación de forma consistente. ${compensateError}`,
            );
          }
        }

        setNeedFetchingDoc(true);
      }
    };

    const precioUniBodyTemplateLocal = (rowDetalle: any) => {
      return formatCurrency(rowDetalle.ocdet_precio_unitario, data.tipmon_id);
    };

    const precioTotBodyTemplateLocal = (rowDetalle: any) => {
      return formatCurrency(rowDetalle.ocdet_precio_total, data.tipmon_id);
    };

    return (
      <div className="p-3">
        <Dialog
          visible={newDetailDialog}
          style={{ width: "50vw" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header={`Nuevo Detalle de Orden N° ${selectedNumeroOrdenCompra}`}
          modal
          className="p-fluid"
          footer={newDetailtDialogFooter}
          onHide={hideNewDialog}
        >
          <div className="card flex justify-content-center">
            <div className="rowEditData" style={{ marginBottom: "0px" }}>
              <div
                className="card flex justify-content-center"
                style={{ marginRight: "20px" }}
              >
                <label style={{ display: "table" }} htmlFor="dd-city">
                  Cantidad
                </label>
                <InputNumber
                  ref={ref}
                  id="os_cantidad_0"
                  placeholder="Cantidad"
                  minFractionDigits={4}
                  locale="de-DE"
                  value={selectedCantidad}
                  min={0}
                  onValueChange={(e: any) => {
                    setSelectedCantidad(e.value);

                    handleQuantityChange(e.value ?? 0, 0);
                    if (
                      selectedCentroCostoId !== undefined &&
                      selectedItemId !== undefined
                    ) {
                      getPptoDisponibleValida(
                        selectedCentroCostoId,
                        selectedItemId,
                        0,
                        selectedMesGastoId,
                      ).then((validaMontoVsPpto) => {
                        const element = document.getElementById(
                          `os_precio_unitario_total_0`,
                        );
                        if (element) {
                          element.style.backgroundColor = validaMontoVsPpto;
                        }
                      });
                    }
                  }}
                  showButtons
                  buttonLayout="horizontal"
                  step={1}
                  decrementButtonClassName="p-button-danger"
                  incrementButtonClassName="p-button-success"
                  incrementButtonIcon="pi pi-plus"
                  decrementButtonIcon="pi pi-minus"
                />
              </div>

              <div className="card flex justify-content-center">
                <label className="labelDialog">Centro de costo</label>
                <DropdownFilter
                  id={`os_centro_costo_0`}
                  labelHead=""
                  initialData={centrosCosto}
                  data={selectedCentroCosto}
                  dataId={selectedCentroCostoId}
                  handleUpdateItems={handleUpdateCentroFromChild}
                  idRow={0}
                  virtualScrollerOptions={{ itemSize: 100 }}
                />
              </div>

              <div className="card flex justify-content-center">
                <label className="labelDialog">Items</label>
                <DropdownFilter
                  id={`os_item_0`}
                  labelHead=""
                  initialData={itemsFiltered.current}
                  data={selectedItem}
                  dataId={selectedItemId}
                  handleUpdateItems={handleUpdateItemFromChild}
                  idRow={0}
                  virtualScrollerOptions={{ itemSize: 100 }}
                />
              </div>

              <div className="card flex justify-content-center">
                <label className="labelDialog">Proveedor</label>
                <DropdownFilter
                  id={`os_proveedor_0`}
                  labelHead=""
                  initialData={proveedores}
                  data={selectedProveedor}
                  dataId={selectedProveedorId}
                  handleUpdateItems={handleUpdateProveedorFromChild}
                  idRow={0}
                  virtualScrollerOptions={{ itemSize: 100 }}
                />
              </div>
            </div>

            <div
              className="card flex justify-content-center"
              style={{
                marginLeft: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className="rowEditData">
                <div className="card flex justify-content-center">
                  <label htmlFor="name" className="labelEditRow">
                    Precio Unitario
                  </label>
                  <InputNumber
                    ref={ref}
                    id="os_precio_unitario_0"
                    value={selectedPrecioUnitarioRef}
                    placeholder="Ingresa el precio del item..."
                    minFractionDigits={4}
                    maxFractionDigits={4}
                    locale="de-DE"
                    min={0}
                    onValueChange={(e) => {
                      const value = e.target.value;
                      setselectedPrecioUnitarioRef(value ?? 0);

                      handlePrecioUnitarioChange(value ?? 0, 0);
                      if (
                        selectedCentroCostoId !== undefined &&
                        selectedItemId !== undefined
                      ) {
                        getPptoDisponibleValida(
                          selectedCentroCostoId,
                          selectedItemId,
                          0,
                          selectedMesGastoId,
                        ).then((validaMontoVsPpto) => {
                          const element = document.getElementById(
                            `os_precio_unitario_total_0`,
                          );
                          if (element) {
                            element.style.backgroundColor = validaMontoVsPpto;
                          }
                        });
                      }
                    }}
                  />
                </div>

                <div
                  className="card flex justify-content-center"
                  style={{ textAlign: "center" }}
                >
                  <label htmlFor="name" className="labelEditRow">
                    Precio Total
                  </label>
                  <InputNumber
                    ref={ref}
                    id="os_precio_unitario_total_0"
                    value={selectedPrecioTotalRef}
                    minFractionDigits={4}
                    maxFractionDigits={4}
                    locale="de-DE"
                    min={0}
                    disabled
                  />
                  <span
                    id={`ppto_error_0`}
                    style={{ fontSize: "10px", color: "red" }}
                  ></span>
                </div>

                <div
                  className="card flex justify-content-center"
                  style={{ marginLeft: "20px", width: "100%" }}
                  onPaste={(e) => {
                    e.preventDefault();
                    showMsg(
                      toast,
                      "warn",
                      "Advertencia",
                      "El pegado de texto está deshabilitado para este campo.",
                    );
                  }}
                >
                  <label
                    htmlFor="name"
                    className="labelEditRow"
                    style={{ display: "table-caption" }}
                  >
                    Detalles Adicionales
                    {textAreaRender()}
                  </label>
                </div>
              </div>
            </div>
            <div className="rowEditData" style={{ marginTop: "0px" }}>
              <Button
                className="buttonformrow"
                style={{ width: "50%", margin: "10px", textAlign: "center" }}
                onClick={saveNewDetail}
              >
                Guardar cambios
              </Button>
            </div>
          </div>
        </Dialog>

        {showModalConfirm ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <ModalConfirm
              header="Confirmación"
              text="¿Estás seguro de editar la orden de compra?"
              show={true}
              setShowModalConfirm={setShowModalConfirm}
              setDocId={0}
              setNeedFetchingDoc={setNeedFetchingDoc}
              data={jsonDataOrdenCompra}
              jsonDestination="editaordencompra"
              data2=""
              setGoHome={setGoHome}
            />
          </div>
        ) : null}

        {showModalConfirmNewDetail ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <ModalConfirm
              header="Confirmación"
              text="¿Estás seguro de agregar el nuevo detalle a la orden de compra?"
              show={true}
              setShowModalConfirm={setShowModalConfirmNewDetail}
              setDocId={0}
              setNeedFetchingDoc={setNeedFetchingDoc}
              data={jsonDataOrdenCompra}
              jsonDestination="nvodetallesorden"
              data2=""
              setGoHome={setGoHome}
            />
          </div>
        ) : null}

        <div style={{ display: "flex" }}>
          <h5 style={{ margin: "5px 0 10px 0" }}>
            Detalle del número orden: {data.oc_id}
            <p
              style={{
                color: "black",
                fontSize: "8px",
                margin: 0,
                fontWeight: "normal",
              }}
            >
              Detalles de solicitudes asociados:
              {data.detalle.map((item: any, index: number) => (
                <span key={`soc_oc_${item.ocdet_id}`}>
                  {index > 0 ? "," : ""}
                  {item.ocdet_id_solicitud_orden_compra_detalle}
                </span>
              ))}
            </p>
          </h5>

          {contextmenu == "visualmontos" ? (
            <Button
              label="MARCAR VISTO"
              icon="pi pi-eye-slash"
              severity="success"
              onClick={() => addMarcaVista(data)}
              style={{
                height: "40px",
                marginLeft: "15px",
                marginRight: "5px",
                padding: "5px",
              }}
            />
          ) : null}
          {/*<Button
            label="Nuevo Detalle"
            icon="pi pi-plus"
            severity="success"
            onClick={() => addNewDetail(data)}
            style={{
              height: "30px",
              marginLeft: "15px",
              marginRight: "5px",
              padding: "5px",
            }}
          />*/}
          {
            //data.socest_id < 7 ? (
            <Button
              label="ORDEN PDF ↓"
              className="btn-cinematic"
              style={{
                maxWidth: "5rem",
              }}
              onClick={() => {
                SHOW_MSG_ACTION(
                  toast,
                  "warning",
                  "Advertencia",
                  "Los protocolos internos prohíben enviar órdenes de compra a proveedores, este es un procedimiento exclusivo del departamento de abastecimiento.",
                  () => handleGeneratePdfOc(data),
                );
              }}
            />
            /*) : (
            <DownloadFiles
              path={`solicitudes/${ano}/${mes}/${data.soc_id}/pdf`}
              numDoc={data.soc_id}
              className="btnArchivoDialog"
              pdf={true}
            ></DownloadFiles>
          )*/
          }

          {contextmenu == "mantiene" &&
          initData.id_centro_costo == CENTRO_COSTO_ADQUISICION ? (
            <Button
              label="ANULAR ORDEN"
              icon="pi pi-ban"
              severity="danger"
              onClick={() => confirmarAnulacion(data)}
              className="btn-cinematic"
              style={{
                maxWidth: "5rem",
                padding: "5px",
                backgroundColor: "#a18e8e",
              }}
            />
          ) : null}

          <div
            style={{
              color: "black",
              fontSize: "8px",
              margin: 0,
              fontWeight: "normal",
            }}
          >
            {archivoBodyTemplate(data)}
          </div>
        </div>

        <Dialog
          header="Subir archivos a la orden"
          visible={dialogVisible}
          style={{ width: "55vw" }}
          modal
          contentStyle={{ height: "400px" }}
          onHide={() => setDialogVisible(false)}
        >
          <UploadFile
            typeDoc="ordenes"
            id={data.oc_id}
            ano={ano}
            mes={mes}
            setDialogVisible={setDialogVisible}
          />
        </Dialog>

        <Dialog
          id="dialogEditionSolicitude"
          className="oc-estado-dialog"
          maskClassName="oc-estado-dialog-mask"
          header={
            <div className="oc-estado-header">
              <span className="oc-estado-header__icon">
                <i className="pi pi-check-square" />
              </span>
              <div className="oc-estado-header__text">
                <span className="oc-estado-header__eyebrow">
                  Cambio de estado
                </span>
                <span className="oc-estado-header__title">
                  Orden N° {selectedNumeroOrdenCompra}
                </span>
              </div>
            </div>
          }
          visible={dialogEditaEstadoOc}
          modal
          blockScroll
          draggable={false}
          onHide={() => setDialogEditaEstadoOc(false)}
          footer={
            <div className="oc-estado-footer">
              <Button
                type="button"
                label="Cancelar"
                icon="pi pi-times"
                className="oc-estado-btn oc-estado-btn--ghost"
                onClick={() => setDialogEditaEstadoOc(false)}
              />
              {initData?.firma !== null ? (
                <Button
                  type="button"
                  label="Guardar estado"
                  icon="pi pi-save"
                  className="oc-estado-btn oc-estado-btn--primary"
                  onClick={() => {
                    setLoadingMessage("Iniciando proceso...");
                    setShowModalLoadSpinner(true);
                    sendNewApprovalStateOrden(data).then((response) => {
                      if (
                        (response?.estado == 8 || response?.estado == 10) &&
                        response.goInet === true
                      ) {
                        sendOrdenCompraToInet(data, data.oc_id, response).then(
                          () => {
                            setShowModalLoadSpinner(false);
                          },
                        );
                      }
                    });
                  }}
                  disabled={initData?.firma === "" ? true : false}
                />
              ) : null}
            </div>
          }
        >
          <div className="oc-estado-body">
            <section className="oc-estado-resumen" id="pDialogEditSolicitude">
              <div className="oc-estado-resumen__top">
                <span className="oc-estado-chip">
                  <i className="pi pi-hashtag" />
                  Detalle {selectedRow?.ocdet_id}
                </span>
                <span className="oc-estado-resumen__hint">
                  Monto solicitado
                </span>
              </div>
              <div className="oc-estado-resumen__monto">
                {formatCurrency(
                  parseFloat(selectedRow?.ocdet_precio_total ?? "0"),
                )}
                <span className="oc-estado-resumen__moneda">
                  {data.tipmon_nombre}
                </span>
              </div>
              <div className="oc-estado-resumen__cc">
                <i className="pi pi-building" />
                <span>
                  Centro de costo: <strong>{selectedRow?.sdetcc_nombre}</strong>
                </span>
              </div>
            </section>

            <div className="oc-estado-field">
              <span className="oc-estado-label" id="oc-estado-label-estado">
                Nuevo estado
              </span>
              <DropdownFilter
                id="os_estado_solicitud_0"
                labelHead=""
                className="oc-estado-dropdown"
                panelClassName="oc-estado-dropdown-panel"
                virtualScroll={false}
                filterInputAutoFocus={false}
                initialData={
                  initData.roles.some(
                    (role: { codigo: string }) =>
                      role.codigo === "APROC" && contextmenu == "aprueba",
                  )
                    ? estadosOrdenes.filter(
                        (element) => ![3, 5, 7, 8, 9, 10].includes(element.id),
                      )
                    : initData.roles.some(
                          (role: { codigo: string }) =>
                            role.codigo === "CONFOC" &&
                            contextmenu == "confirma",
                        )
                      ? (!USUARIO_CONFIRMA_GTE_GENERAL.includes(initData.id) &&
                          (subroganteVal == true ||
                            initData.id == USUARIO_TI ||
                            USUARIOS_CONFIRMACION_ORDENES.includes(
                              initData.id,
                            ))) ||
                        USUARIO_CONFIRMA_GTE_GENERAL.includes(initData.id)
                        ? estadosOrdenes.filter(
                            (element) =>
                              ![
                                3,
                                5,
                                6,
                                7,
                                9,
                                selectedRow?.ocest_id == 6 ? 10 : null,
                              ].includes(element.id),
                          )
                        : estadosOrdenes.filter(
                            (element) =>
                              ![2, 3, 5, 6, 7, 8, 9, 10].includes(element.id),
                          )
                      : contextmenu == "visualmontos"
                        ? estadosOrdenes.filter(
                            (element) =>
                              ![1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(
                                element.id,
                              ),
                          )
                        : null
                }
                data={selectedEstado}
                dataId={selectedEstadoId}
                handleUpdateItems={handleUpdateEstadoFromChild}
                idRow={0}
                virtualScrollerOptions={{ itemSize: 100 }}
              />
            </div>

            {initData?.firma == null ? (
              <div className="oc-estado-firma">
                <i className="pi pi-pencil" />
                <div className="oc-estado-firma__text">
                  <strong>Necesitas una firma digital</strong>
                  <span>Créala para poder guardar el estado de la orden.</span>
                </div>
                <Button
                  type="button"
                  label="Crea tu firma"
                  className="oc-estado-btn oc-estado-btn--secondary"
                  onClick={() => setShowModalFirma(true)}
                />
              </div>
            ) : null}

            {showModalFirma ? (
              <ModalSignature setShowModalSignature={setShowModalFirma} />
            ) : null}

            <div className="oc-estado-field" id="taDialogEditSolicitude">
              <span className="oc-estado-label" id="oc-estado-label-just">
                Justificaciones
              </span>
              <div
                contentEditable="true"
                suppressContentEditableWarning={true}
                role="textbox"
                aria-multiline="true"
                aria-labelledby="oc-estado-label-just"
                data-placeholder="Escribe aquí la justificación del cambio de estado..."
                className="oc-estado-textarea"
                id="os_justificacion"
                onChange={(e) => handleUpdateJustificacion(e)}
              >
                {selectedJustificacion.current}
              </div>
            </div>
          </div>
        </Dialog>

        <Dialog
          style={{ width: "45vw" }}
          header={`Edición de detalle de orden N° ${selectedNumeroOrdenCompra}`}
          visible={dialogEditaDetalleVisible}
          maximizable
          modal
          contentStyle={{ height: "60vw" }}
          onHide={() => setDialogEditaDetalleVisible(false)}
        >
          {selectedRow != null ? (
            <div className="card flex justify-content-center">
              <div className="rowEditData">
                <div className="card flex justify-content-center">
                  <label className="labelDialog">Tipo Solicitud</label>
                  <DropdownFilter
                    id="os_tipo_solicitud_0"
                    labelHead=""
                    initialData={tipoSolicitudes}
                    data={selectedTipoOrden}
                    dataId={selectedTipoOrdenId}
                    handleUpdateItems={handleUpdateTipoSolFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                    disabled={true}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Mes Gasto</label>
                  <DropdownFilter
                    id={`os_mes_0`}
                    labelHead=""
                    initialData={meses}
                    data={selectedMesGasto}
                    dataId={selectedMesGastoId}
                    handleUpdateItems={handleUpdateMesFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Estado Operacional</label>
                  <DropdownFilter
                    id="os_estado_operacional_0"
                    labelHead=""
                    initialData={estadosOperacionales}
                    data={selectedEstadoOp}
                    dataId={selectedEstadoOpId}
                    handleUpdateItems={handleUpdateEstadoOpeFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Condición Pago</label>
                  <DropdownFilter
                    id="os_condicion_pago_0"
                    labelHead=""
                    initialData={condicionesPago}
                    data={selectedCondicionPago}
                    dataId={selectedCondicionPagoId}
                    handleUpdateItems={handleUpdateCondicionPagoFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>
              </div>

              <div className="rowEditData">
                <div className="card flex justify-content-center">
                  <label className="labelDialog">Tipo Moneda</label>
                  <DropdownFilter
                    id="os_tipo_moneda_0"
                    labelHead=""
                    initialData={tiposMoneda}
                    data={selectedTipoMoneda}
                    dataId={selectedTipoMonedaId}
                    handleUpdateItems={handleUpdateTipoMonFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label style={{ fontSize: "10px" }} className="labelDialog">
                    Documento Tributario
                  </label>
                  <DropdownFilter
                    id="os_tipo_doc_tributario_0"
                    labelHead=""
                    initialData={tiposDocumentosTributarios}
                    data={selectedTipoDocTributario}
                    dataId={selectedTipoDocTributarioId}
                    handleUpdateItems={handleUpdateTipoDocTributarioFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Proveedor</label>
                  <DropdownFilter
                    id={`os_proveedor_0`}
                    labelHead=""
                    initialData={proveedores}
                    data={selectedProveedor}
                    dataId={selectedProveedorId}
                    handleUpdateItems={handleUpdateProveedorFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>
              </div>

              <hr
                id="separator"
                style={{ width: "100%", marginBottom: "20px" }}
              />

              <div className="rowEditData" style={{ marginBottom: "0px" }}>
                <div
                  className="card flex justify-content-center"
                  style={{ marginRight: "20px" }}
                >
                  <label style={{ display: "table" }} htmlFor="dd-city">
                    Cantidad
                  </label>
                  <InputNumber
                    ref={ref}
                    id="os_cantidad_0"
                    placeholder="Cantidad"
                    minFractionDigits={4}
                    locale="de-DE"
                    value={selectedCantidad}
                    min={0}
                    onValueChange={(e: any) => {
                      setSelectedCantidad(e.value);

                      handleQuantityChange(e.value ?? 0, 0);
                      if (
                        selectedCentroCostoId !== undefined &&
                        selectedItemId !== undefined
                      ) {
                        getPptoDisponibleValida(
                          selectedCentroCostoId,
                          selectedItemId,
                          0,
                          selectedMesGastoId,
                        ).then((validaMontoVsPpto) => {
                          const element = document.getElementById(
                            `os_precio_unitario_total_0`,
                          );
                          if (element) {
                            element.style.backgroundColor = validaMontoVsPpto;
                          }
                        });
                      }
                    }}
                    showButtons
                    buttonLayout="horizontal"
                    step={1}
                    decrementButtonClassName="p-button-danger"
                    incrementButtonClassName="p-button-success"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Centro de costo</label>
                  <DropdownFilter
                    id={`os_centro_costo_0`}
                    labelHead=""
                    initialData={centrosCosto}
                    data={selectedCentroCosto}
                    dataId={selectedCentroCostoId}
                    handleUpdateItems={handleUpdateCentroFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Items</label>
                  <DropdownFilter
                    id={`os_item_0`}
                    initialData={itemsFiltered.current}
                    data={selectedItem ?? ""}
                    dataId={selectedItemId ?? 0}
                    handleUpdateItems={handleUpdateItemFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>
              </div>

              <div
                className="card flex justify-content-center"
                style={{
                  marginLeft: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div className="rowEditData">
                  <div className="card flex justify-content-center">
                    <label htmlFor="name" className="labelEditRow">
                      Precio Unitario
                    </label>
                    <InputNumber
                      ref={ref}
                      id="os_precio_unitario_0"
                      value={selectedPrecioUnitarioRef}
                      placeholder="Ingresa el precio del item..."
                      minFractionDigits={4}
                      maxFractionDigits={4}
                      locale="de-DE"
                      min={0}
                      onValueChange={(e) => {
                        const value = e.target.value;
                        setselectedPrecioUnitarioRef(value ?? 0);

                        handlePrecioUnitarioChange(value ?? 0, 0);
                        if (
                          selectedCentroCostoId !== undefined &&
                          selectedItemId !== undefined
                        ) {
                          getPptoDisponibleValida(
                            selectedCentroCostoId,
                            selectedItemId,
                            0,
                            selectedMesGastoId,
                          ).then((validaMontoVsPpto) => {
                            const element = document.getElementById(
                              `os_precio_unitario_total_0`,
                            );
                            if (element) {
                              element.style.backgroundColor = validaMontoVsPpto;
                            }
                          });
                        }
                      }}
                    />
                  </div>

                  <div
                    className="card flex justify-content-center"
                    style={{ textAlign: "center" }}
                  >
                    <label htmlFor="name" className="labelEditRow">
                      Precio Total
                    </label>
                    <InputNumber
                      ref={ref}
                      id="os_precio_unitario_total_0"
                      value={selectedPrecioTotalRef}
                      minFractionDigits={4}
                      maxFractionDigits={4}
                      locale="de-DE"
                      min={0}
                      disabled
                    />
                    <span
                      id={`ppto_error_0`}
                      style={{ fontSize: "10px", color: "red" }}
                    ></span>
                  </div>

                  <div
                    className="card flex justify-content-center"
                    style={{ marginLeft: "20px", width: "100%" }}
                    onPaste={(e) => {
                      e.preventDefault();
                      showMsg(
                        toast,
                        "warn",
                        "Advertencia",
                        "El pegado de texto está deshabilitado para este campo.",
                      );
                    }}
                  >
                    <label
                      htmlFor="name"
                      className="labelEditRow"
                      style={{ display: "table-caption" }}
                    >
                      Detalles Adicionales
                      {textAreaRender()}
                    </label>
                  </div>
                </div>
              </div>
              <div className="rowEditData" style={{ marginTop: "0px" }}>
                <Button
                  className="buttonformrow"
                  style={{ width: "50%", margin: "10px", textAlign: "center" }}
                  onClick={saveOrdenEdition}
                >
                  Guardar cambios
                </Button>
              </div>
            </div>
          ) : null}
        </Dialog>
        <DataTable
          value={data.detalle}
          selectionMode="single"
          selection={selectedRow}
          onSelectionChange={(e: any) => {
            //AQUI ENTRA LOS ROLES POR USUARIOS QUE PUEDEN EDITAR SU SOLICITUD CENTRO O USUARIOS QUE APRUEBAN //
            // LOS QUE APRUEBAN NO EDITAN DATOS , LOS QUE EDITAN DATOS NO APRUEBAN //
            const dataVal = e.value;
            setSelectedRow(dataVal);
            setSelectedNumeroOrdenCompra(data.oc_id);

            //EN ORDENES SE PERMITE EDITAR DETALLES DE OTRAS PERSONAS PORQUE ESTO ES SOLO ADQUISICION //  data.user_id === initData.id &&

            if (
              initData.roles.some(
                (role: { codigo: string }) => role.codigo === "MANOC",
              ) &&
              contextmenu == "mantiene"
            ) {
              if (dataVal.ocest_id == 6 && USUARIO_TI !== initData.id) {
                showMsg(
                  toast,
                  "warn",
                  "Advertencia",
                  "No puedes editar detalles de órdenes que se encuentren aprobadas.",
                );
              } else if (
                dataVal.ocest_id == 8 ||
                dataVal.ocest_id == 9 ||
                dataVal.ocest_id == 10
              ) {
                showMsg(
                  toast,
                  "warn",
                  "Advertencia",
                  "No puedes editar detalles de órdenes que se encuentren, confirmadas o pendientes en gerencia.",
                );
              } else if (
                (dataVal.ocest_id == 2 || dataVal.ocest_id == 4) &&
                USUARIO_TI !== initData.id
              ) {
                showMsg(
                  toast,
                  "warn",
                  "Advertencia",
                  "No puedes editar detalles de órdenes que se encuentren rechazadas o anuladas.",
                );
              } else if (
                data.user_id !== initData.id &&
                contextmenu == "mantiene" &&
                initData.id !== USUARIO_TI
              ) {
                showMsg(
                  toast,
                  "warn",
                  "Advertencia",
                  "No puedes editar detalles de órdenes que no has creado.",
                );
              } else if ((contextmenu as string) == "visualmontos") {
                showMsg(
                  toast,
                  "warn",
                  "Advertencia",
                  "No puedes editar detalles de órdenes, solo visualizar montos.",
                );
                return;
              } else {
                setSelectedMesGasto(data.meses_nombre);
                setSelectedMesGastoId(data.meses_id);
                setSelectedEStadoOp(data.estope_nombre);
                setSelectedEstadoOpId(data.estope_id);
                setSelectedCondicionPago(data.condpago_nombre);
                setSelectedCondicionPagoId(data.oc_condicion_pago);
                setSelectedTipoMoneda(data.tipmon_nombre);
                setSelectedTipoMonedaId(data.tipmon_id);
                setSelectedTipoDocTributarioId(data.doctrib_id);
                setSelectedTipoDocTributario(data.doctrib_nombre);
                setSelectedProveedorId(data.prov_id);
                setSelectedProveedor(data.prov_nombre);
                setSelectedTipoOrden(data.subdoc_nombre);
                setSelectedTipoOrdenId(data.subdoc_id);
                setSelectedDetailRowId(data.ocdet_id);

                itemsFiltered.current = FILTER_ITEMS_BY_DOC_TYPE(
                  itemsAdquisicion,
                  data.subdoc_id,
                  tiposItemsAdquisicion,
                );

                setSelectedItem(dataVal.item_nombre);
                setSelectedItemId(dataVal.item_id);
                //setSelectedEstado(data.ocest_nombre);
                //setSelectedEstadoId(data.ocest_id);
                setSelectedCantidad(dataVal.ocdet_cantidad);
                setSelectedCentroCosto(dataVal.sdetcc_nombre);
                setSelectedCentroCostoId(dataVal.sdetcc_id);

                setSelectedEstado(dataVal.ocest_nombre);
                setSelectedEstadoId(dataVal.ocest_id);
                setselectedPrecioUnitarioRef(dataVal.ocdet_precio_unitario);
                setSelectedPrecioTotalRef(dataVal.ocdet_precio_total);
                selectedDetalles.current = dataVal.ocdet_observaciones;
                setSelectedDetailRowId(dataVal.ocdet_id);
                setDialogEditaDetalleVisible(true);
              }
            }

            //MENSAJES INFORMATIVOS APROBADOR
            if (
              initData.roles.some(
                (role: { codigo: string }) => role.codigo === "APROC",
              ) &&
              contextmenu == "aprueba"
            ) {
              if (
                data.user_id === initData.id &&
                initData.crear_aprobar_solicitud == 1
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes aprobar detalles de órdenes que hayas creado.",
                );
              } else if (
                dataVal &&
                dataVal?.sdetcc_id !== initData.id_centro_costo &&
                initData.crear_aprobar_solicitud == 1
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes aprobar detalles de órdenes que no pertenencen a tu centro de costo.",
                );
              }

              //PENDIENTE, RECHAZADA, PARCIALMENTE RECHAZADA
              /*else if (dataVal.ocest_id == 6) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes aprobar detalles de órdenes que ya se encuentren aprobadas"
                );
              }*/
              else if (dataVal && dataVal?.ocest_id > 7) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes aprobar detalles de órdenes que se encuentren confirmadas",
                );
              } else {
                setSelectedEstadoId(0);
                setSelectedEstado("");
                setDialogEditaEstadoOc(true);
              }
            }

            //MENSAJES INFORMATIVOS CONFIRMADOR
            if (
              initData.roles.some(
                (role: { codigo: string }) => role.codigo === "CONFOC",
              ) &&
              contextmenu == "confirma"
            ) {
              if (data.user_id === initData.id && initData.id !== USUARIO_TI) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de órdenes que hayas creado.",
                );
              } /*else if (dataVal.sdetcc_id !== initData.id_centro_costo) { 
              //ESTO NO APLICA PARA CONFIRMACIONES // EN TODO CASO LA VALIDACION DEBE SER CONTRA MULTIPLES CENTROS, PARA EL MVP ASI NO MAS
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de órdenes que no pertenencen a tu centro de costo."
                );
              }*/
              //APROBADA, PARCIALMENTE APROBADA, CONFIRMADA PARCIALMENTE , PENDIENTE GTE , CONFIRMADA GTE
              /*else if (
                data.ocest_id !== 5 &&
                data.ocest_id !== 6 &&
                data.ocest_id !== 7 &&
                data.ocest_id !== 8 &&
                data.ocest_id !== 10 &&
                initData.id_centro_costo !== CENTRO_COSTO_GENERAL
              )*/
              else if (
                !USUARIOS_CONFIRMACION_ORDENES.includes(initData.id) &&
                !USUARIO_CONFIRMA_GTE_GENERAL.includes(initData.id)
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de órdenes, no tienes los permisos necesarios.",
                );
              } else if (
                dataVal.ocest_id !== 6 &&
                dataVal.ocest_id !== 4 &&
                USUARIOS_CONFIRMACION_ORDENES.includes(initData.id) &&
                initData.id !== USUARIO_TI &&
                subroganteVal == false
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de órdenes que no estén aprobadas o rechazadas",
                );
              } else if (
                /*else if (
                data.ocest_id > 7 &&
                initData.id_centro_costo !== CENTRO_COSTO_GENERAL
              ) {
                //CENTRO COSTO GERENTE GENERAL
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de órdenes en una orden ya confirmada",
                );
              }*/
                data.ocest_id < 7 &&
                USUARIO_CONFIRMA_GTE_GENERAL.includes(initData.id)
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes firmar detalles de órdenes sin aprobación del área",
                );
              } else if (
                data.ocest_id === 8 &&
                !USUARIO_CONFIRMA_GTE_GENERAL.includes(initData.id) &&
                USUARIOS_CONFIRMACION_ORDENES.includes(initData.id)
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de órdenes en una orden que ya está generalmente confirmada",
                );
              } /* else if (
                data.ocest_id === 8 &&
                initData.id_centro_costo !== CENTRO_COSTO_GENERAL
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de órdenes ya confirmadas",
                );
              }*/ else if (dataVal.ocest_id == 10) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes firmar detalles de órdenes ya confirmadas por el gerente general",
                );
              } else {
                /*else if (
                (dataVal.ocest_id !== 7 &&
                  dataVal.ocest_id !== 8 &&
                  dataVal.ocest_id !== 9) ||
                data.ocest_id < 7
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes firmar detalles de órdenes que no estén confirmadas"
                );
              }*/
                setSelectedEstadoId(0);
                setSelectedEstado("");
                setDialogEditaEstadoOc(true);
              }
            }

            /*const filteredCc = centrosCostoFull.filter(
              (cc: any) => cc.id_area === initData.area_id
            );

            const CENTROS_DE_AREA_USUARIO = filteredCc.map((cc: any) => cc.id);

            console.log(
              "Centros de área de usuario: ",
              CENTROS_DE_AREA_USUARIO
            );
            console.log("Detalles de la orden: ", dataVal);
            if (
              initData.roles.some(
                (role: { codigo: string }) => role.codigo === "CONFOC"
              ) &&
              data.user_id !== initData.id &&
              contextmenu == "confirma" &&
              CENTROS_DE_AREA_USUARIO.includes(dataVal.sdetcc_id)
            ) {
              if (
                dataVal.ocest_id === 7 ||
                dataVal.ocest_id === 6 ||
                dataVal.ocest_id === 5
              ) {
                setDialogEditaEstadoOc(true);
              } else {
                showMsg(
                  toast,
                  "warn",
                  "Advertencia",
                  "No se pueden confirmar detalles de órdenes no aprobados, "
                );
              }
            }*/
            // }
          }}
          dataKey="ocdet_id"
          metaKeySelection={false}
          tableStyle={{ minWidth: "50rem" }}
        >
          <Column
            field="ocdet_id"
            header="Id"
            sortable
            style={{ maxWidth: "4rem" }}
          ></Column>
          <Column
            field="ocdet_cantidad"
            header="Cantidad"
            style={{ maxWidth: "4rem" }}
          ></Column>
          <Column field="sdetcc_nombre" header="Centro Costo" sortable></Column>
          <Column
            field="item_nombre"
            header="Item"
            sortable
            style={{ maxWidth: "10rem" }}
          ></Column>
          <Column
            field="prov_nombre"
            header="Proveedor"
            style={{ maxWidth: "10rem" }}
            sortable
          ></Column>
          <Column
            field="ocdet_precio_unitario"
            header="Precio Unitario"
            sortable
            body={precioUniBodyTemplateLocal} // <--- Usar la versión local
            style={{ maxWidth: "4rem" }}
            showFilterMenu={false}
          ></Column>
          <Column
            field="ocdet_precio_total"
            header="Precio Total"
            filter
            filterField="ocdet_precio_total"
            filterMatchMode="custom_detail_precio_total_filter"
            body={precioTotBodyTemplateLocal} // <--- Usar la versión local
            showFilterMenu={false}
            style={{ maxWidth: "4rem" }}
          ></Column>
          <Column
            body={() => data.tipmon_codigo}
            style={{
              width: "3rem",
              fontWeight: "bold",
              fontSize: "9px",
            }}
          ></Column>
          <Column
            field="ocest_nombre"
            header="Estado"
            body={estadoBodyTemplate}
            sortable
          ></Column>
          <Column
            field="suda_nombre_usuario"
            header="Aprobador"
            sortable
            style={{ maxWidth: "6rem" }}
          ></Column>
          <Column
            field="ocdet_observaciones"
            header="Detalles"
            style={{ maxWidth: "12rem" }}
          ></Column>
        </DataTable>
      </div>
    );
  };

  //************************************************************************************************/
  //************************************************************************************************/
  //************************************************************************************************/

  // Icono de la cabecera segun el contexto de la pantalla
  const iconoCabecera =
    contextmenu == "aprueba"
      ? "pi-check-square"
      : contextmenu == "confirma"
        ? "pi-verified"
        : contextmenu == "visualmontos"
          ? "pi-exclamation-circle"
          : "pi-pencil";

  const header = (
    <div className="om-header">
      <header className="om-hero">
        <div className="om-hero-main">
          <div className="om-hero-icon" aria-hidden="true">
            <i className={`pi ${iconoCabecera}`} />
          </div>
          <div className="om-hero-text">
            <span className="om-eyebrow">Compras · Órdenes de compra</span>
            <h2 className="om-title">
              {contextmenu == "confirma"
                ? "Confirmación de órdenes de compra"
                : null}
              {contextmenu == "aprueba"
                ? "Aprobación de órdenes de compra"
                : null}
              {contextmenu == "mantiene"
                ? "Edición de órdenes de compra"
                : null}
              {contextmenu == "visualmontos"
                ? "Visualización de órdenes de compra de montos altos"
                : null}
            </h2>
            <p className="om-hero-desc">
              {contextmenu == "mantiene"
                ? "En este módulo podrá editar órdenes de compra, visualizar en pdf, adjuntar y descargar archivos en las órdenes."
                : null}
              {contextmenu == "aprueba"
                ? "En este módulo podrá aprobar órdenes de compra correspondientes a su rol, visualizar en pdf, adjuntar y descargar archivos en las órdenes."
                : null}
              {contextmenu == "confirma"
                ? "En este módulo podrá confirmar órdenes de compra correspondientes a su rol, visualizar en pdf, adjuntar y descargar archivos en las órdenes."
                : null}

              {contextmenu == "visualmontos"
                ? "En este módulo podrá visualizar las órdenes de compra ya confirmadas y enviadas a proveedor de montos mayores a $90 millones de pesos."
                : null}
            </p>
          </div>
        </div>
        <EstadosOrdenLeyenda />
      </header>

      <section className="om-filtros" aria-label="Filtros avanzados">
        <div className="om-filtros-head">
          <span className="om-filtros-title">
            <i className="pi pi-sliders-h" aria-hidden="true" />
            Filtros avanzados
          </span>
        </div>
        <div className="eol-toolbar om-toolbar">
          <div className="eol-filtro">
            <label htmlFor="filtro_centro_costo_destino">
              Centro Costo Destino
            </label>
            <span className="eol-filtro-input">
              <i className="pi pi-search" aria-hidden="true" />
              <InputText
                id="filtro_centro_costo_destino"
                value={filters.centros_costo_destino?.value ?? ""}
                onChange={(e) => onCentroCostoDestinoChange(e.target.value)}
                placeholder="Nombre del centro de costo.."
                title="Busca órdenes por el centro de costo de sus líneas de detalle (no el del solicitante)"
              />
              {filters.centros_costo_destino?.value ? (
                <button
                  type="button"
                  className="eol-filtro-limpiar"
                  onClick={() => onCentroCostoDestinoChange("")}
                  aria-label="Limpiar filtro Centro Costo Destino"
                >
                  <i className="pi pi-times" style={{ fontSize: "0.7rem" }} />
                </button>
              ) : null}
            </span>
          </div>

          {/*<Button style={{width: '55px', height: '30px', backgroundColor: 'green', marginBottom: '10px', marginRight: '5px'}} type="button" icon="pi pi-file" rounded onClick={exportCSV(false)} data-pr-tooltip="CSV">CSV</Button>*/}
          <div className="om-descarga">
            <Button
              className="om-btn-excel"
              type="button"
              icon="pi pi-download"
              onClick={exportExcel}
              data-pr-tooltip="XLS"
              title="Descarga en un archivo Excel todas las órdenes de la tabla (sin aplicar filtros): hoja Cabecera OC y hoja Detalles OC"
            >
              Descargar Excel
            </Button>
            <span className="om-descarga-nota">
              <i className="pi pi-file-excel" aria-hidden="true" /> Toda la
              tabla: cabecera y detalle de las órdenes
            </span>
          </div>
        </div>
      </section>

      {/*<Button type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={exportPdf} data-pr-tooltip="PDF" />*/}
    </div>
  );

  return (
    <div
      className="card om-screen"
      style={{
        padding: "20px calc(20px + var(--rp-scrollbar-width, 0px)) 20px 20px",
      }}
    >
      {showModalLoadSpinner ? (
        <ModalLoadSpinner message={loadingMessage} />
      ) : null}
      <Toast ref={toast} />

      <ConfirmDialog />

      <Tooltip target=".export-buttons>button" position="bottom" />
      {cargandoDatos ? (
        <CargandoDatos
          mensaje="Cargando los datos de las órdenes"
          icono="pi-shopping-cart"
          tema="ordenes"
        />
      ) : (
        <DataTable
          value={data}
          paginator
          rows={10}
          dataKey="oc_id"
          filters={filters}
          onFilter={onFilterChange}
          filterDisplay="row"
          loading={isLoading}
          globalFilterFields={[
            "tipmon_nombre",
            "subdoc_nombre",
            "item_nombre",
            "oc_id",
            "nombres",
            "apellidos",
            "cc_nombre",
            "oc_dt_cre",
            "ocest_nombre",
          ]}
          header={header}
          emptyMessage="No se encontraron órdenes de compra..."
          expandedRows={expandedRows}
          onRowToggle={(e) =>
            setExpandedRows(e.data as DataTableExpandedRows[] | undefined)
          }
          onRowExpand={onRowExpand}
          onRowCollapse={onRowCollapse}
          rowExpansionTemplate={rowExpansionTemplate}
          tableStyle={{ minWidth: "30rem", width: "100%" }}
        >
          <Column body={togglerTemplate} style={{ width: "3rem" }} />
          <Column
            field="detalle" // Points to the array in the main object
            header="Proveedor"
            style={{ maxWidth: "10rem" }}
            filter
            filterMatchMode="custom_detail_proveedor_filter"
            filterPlaceholder="Proveedor..."
            body={mainProveedorTemplate} // Shows info in the main row
            showFilterMenu={false}
          />
          <Column
            field="subdoc_nombre"
            header="Tipo Orden"
            filter
            filterPlaceholder="Tipo."
            style={{ maxWidth: "7rem" }}
            showFilterMenu={false}
          />
          <Column
            field="soc_id"
            header="N° Solicitud"
            filter
            filterPlaceholder="Soc."
            style={{ maxWidth: "6rem" }}
            showFilterMenu={false}
          />
          <Column
            field="oc_id"
            header="N° Orden"
            filter
            filterPlaceholder="Ord."
            filterMenuStyle={{}}
            style={{ maxWidth: "6rem" }}
            showFilterMenu={false}
          />
          <Column
            field="busqueda_solicitante" /* Usamos tu campo existente */
            header="Solicitante / Centro"
            body={solicitanteFusionadoBodyTemplate}
            filter
            filterFunction={
              filtroNombreOCentro
            } /* Agregamos la regla "O" (OR) */
            filterElement={singleFilterSolicCentroElement}
            showFilterMatchModes={false}
            showApplyButton={false}
            showClearButton={false}
            style={{ maxWidth: "8rem" }}
            showFilterMenu={false}
          />
          <Column
            field="oc_dt_cre"
            header="Fecha Creación"
            filter
            filterPlaceholder="Fecha."
            style={{ maxWidth: "6rem" }}
            showFilterMenu={false}
          />
          <Column
            header="Estado Orden"
            field="ocest_nombre"
            showFilterMenu={false}
            style={{ maxWidth: "6rem" }}
            body={estadoBodyTemplate}
            filter
            filterPlaceholder="Estado."
            filterElement={estadoRowFilterTemplate}
          />
          <Column
            header="Aprobador"
            field="aprobadores_combinados"
            body={aprobadorBodyTemplate}
            filter
            //filterFunction={filtroAprobador} /* Agregamos la regla "O" (OR) */
            //filterElement={singleFilterAprobadorElement}
            filterMatchMode="custom_detail_aprobador_filter"
            filterPlaceholder="Nombre."
            showFilterMatchModes={false}
            showApplyButton={false}
            showClearButton={false}
            filterHeaderStyle={{ width: "6rem" }}
            style={{ maxWidth: "8rem" }}
            showFilterMenu={false}
          />
          <Column
            field="estope_nombre"
            header="Estado Oper."
            filter
            filterPlaceholder="EO."
            style={{ width: "6rem", minWidth: "6rem" }}
            showFilterMenu={false}
            showFilterMatchModes={false}
            showApplyButton={false}
            showClearButton={false}
          />
        </DataTable>
      )}
    </div>
  );
}

export default TableDataOrderMaintenance;
